import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  Component,
  effect,
  ElementRef,
  HostListener,
  inject,
  ViewChild,
} from '@angular/core';
import { CategoryService } from 'src/app/services/category';
import { LocaleService } from 'src/app/services/locale';
import { ButtonComponent } from '../../shared/button';
import { ArrowLeftComponent } from '../../icons/arrow-left';
import { ArrowRightComponent } from '../../icons/arrow-right';
import { QuestionComponent } from '../../icons/question';
import { InfoComponent } from '../../icons/info';
import { DoneComponent } from '../../icons/done';
import { ProgressComponent } from '../../icons/progress';
import { TodoComponent } from '../../icons/todo';
import { APIService } from 'src/app/services/api';
import { UserService } from 'src/app/services/user';
import { Category1Question1Component } from './questions/category1/question1';
import { Category1Question2Component } from './questions/category1/question2';
import { Category1Question3Component } from './questions/category1/question3';
import { Category1Question4Component } from './questions/category1/question4';
import { Category1Question5Component } from './questions/category1/question5';
import { Category1Question6Component } from './questions/category1/question6';
import { Category1Question7Component } from './questions/category1/question7';
import { Category1Question8Component } from './questions/category1/question8';
// import { Category2Question1Component } from "./questions/category2/question1"; // Cat 2 Q1 removed per client request
import { Category2Question2Component } from './questions/category2/question2';
import { Category2Question3Component } from './questions/category2/question3';
import { ClimatiqService } from 'src/app/services/climatiq';
import { MapComponent } from '../../icons/map';
import { InboxComponent } from '../../icons/inbox';
import { CalculationSummary, EmissionTotals } from './summary';
import { Category3Question3Component } from './questions/category3/question3';
import { Category3Question34Component } from './questions/category3/question3-4';
import { Category3Question1Component } from './questions/category3/question1';
import { Category3Question2Component } from './questions/category3/question2';
import { Category3Question4Component } from './questions/category3/question4';
import { Category3Question5Component } from './questions/category3/question5';
import { Category4Question1Component } from './questions/category4/question1';
import { Category4Question2Component } from './questions/category4/question2';
import { Category4Question3Component } from './questions/category4/question3';
import { Category4Question4Component } from './questions/category4/question4';
import { Category4Question5Component } from './questions/category4/question5';
import { SharedStateService } from 'src/app/services/category.service';
import { Category5Question2Component } from './questions/category5/question2';
import { Category5Question3Component } from './questions/category5/question3';
import { Category5Question4Component } from './questions/category5/question4';
import { Category5Question1Component } from './questions/category5/question1';
import { Category6Question1Component } from './questions/category6/question1';
import { DropdownComponent } from 'src/app/components/shared/dropdown';
import { FormControl, FormGroup, FormsModule } from '@angular/forms';
import { debounceTime, merge } from 'rxjs';
import { InviteService, InviteRecord } from 'src/app/services/invite';
type ViewState = 'question' | 'matrix' | 'stepCompleted' | 'summary';

@Component({
  selector: 'app-calculation-categories',
  imports: [
    CommonModule,
    RouterModule,
    ButtonComponent,
    ArrowLeftComponent,
    ArrowRightComponent,
    QuestionComponent,
    InfoComponent,
    DoneComponent,
    ProgressComponent,
    TodoComponent,
    DropdownComponent,
    FormsModule,
    Category1Question1Component,
    Category1Question2Component,
    Category1Question3Component,
    Category1Question4Component,
    Category1Question5Component,
    Category1Question6Component,
    Category1Question7Component,
    Category1Question8Component,
    /* Category2Question1Component, */ Category2Question2Component,
    Category2Question3Component,
    MapComponent,
    InboxComponent,
    CalculationSummary,
    Category3Question3Component,
    Category3Question1Component,
    Category3Question2Component,
    Category3Question4Component,
    Category3Question5Component,
    Category4Question1Component,
    Category4Question2Component,
    Category4Question3Component,
    Category4Question4Component,
    Category4Question5Component,
    Category5Question2Component,
    Category5Question3Component,
    Category5Question4Component,
    Category5Question1Component,
    Category6Question1Component,
  ],
  template: `
    <div
      class="mt-22 sm:mt-24 flex flex-col w-full gap-2 sm:gap-3 px-2 sm:px-3 lg:px-4 pb-4"
    >
      <!-- Subscribe Prompt for Invited Users on locked categories -->
      <div
        *ngIf="
          isInvitedUser &&
          currentCategory >= 2 &&
          currentViewState !== 'summary'
        "
        class="w-full bg-white border border-gray-200 shadow-lg p-4 sm:p-6 rounded-xl max-w-7xl m-auto"
      >
        <div
          class="flex flex-col items-center justify-center py-12 px-6 text-center"
        >
          <div
            class="w-16 h-16 bg-[#043B22]/10 rounded-full flex items-center justify-center mb-6"
          >
            <svg
              class="w-8 h-8 text-[#043B22]"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              ></path>
            </svg>
          </div>
          <h3 class="futura text-xl sm:text-2xl font-bold text-[#043B22] mb-3">
            {{
              language === 'english'
                ? 'Unlock Your Full Report'
                : 'Sblocca il tuo report completo'
            }}
          </h3>
          <p
            class="text-sm sm:text-base text-[#616161] max-w-md mb-8 leading-relaxed"
          >
            {{
              language === 'english'
                ? 'Subscribe to access all 6 categories, generate detailed emission reports, and get a complete carbon footprint analysis for your company.'
                : 'Abbonati per accedere a tutte le 6 categorie, generare report dettagliati sulle emissioni e ottenere un analisi completa dell impronta di carbonio della tua azienda.'
            }}
          </p>
          <a
            routerLink="/dashboard/profile"
            class="inline-flex items-center gap-2 bg-[#043B22] text-white px-8 py-3 rounded-xl futura text-sm sm:text-base font-medium hover:bg-[#065a35] transition-all duration-200 shadow-md hover:shadow-lg"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
              ></path>
            </svg>
            {{ locale.common.subscribe || 'SUBSCRIBE' }}
          </a>
        </div>
      </div>

      <div
        *ngIf="
          currentViewState === 'question' &&
          !(isInvitedUser && currentCategory >= 2)
        "
      >
        <div *ngFor="let category of categories; let i = index">
          <div
            *ngIf="i === currentCategory"
            class="w-full bg-white border border-gray-100 shadow-sm p-2 sm:p-3 rounded-lg m-auto"
          >
            <div class="flex items-start justify-between gap-3">
              <div class="flex-1">
                <div
                  class="font-bold text-[16px] sm:text-[18px] futura text-[#043B22]"
                >
                  {{ locale.category.heading_category }} {{ i + 1 }}
                </div>
                <div class="text-[11px] sm:text-[12px] text-[#616161] mt-0.5">
                  {{ locale.category.subheading_category }}
                  {{ visibleQuestionNumber(i, currentQuestion) }}
                  {{ locale.category.subheading_category_s }}
                  {{ visibleQuestionCount(i) }}
                </div>
              </div>
              <div
                *ngIf="calculationName"
                class="flex-shrink-0 bg-[#043B22]/10 px-3 py-1.5 rounded-lg border border-[#043B22]/20"
              >
                <div class="text-[10px] text-[#616161] tracking-wide">
                  {{ language === 'english' ? 'Calculation' : 'Calcolo' }}
                </div>
                <div
                  class="text-[12px] sm:text-[13px] text-[#043B22] font-semibold"
                  [title]="calculationName"
                >
                  {{ calculationName }}
                </div>
              </div>
            </div>

            <div class="w-full bg-[#DFE7EF] h-px my-1.5 sm:my-2"></div>

            <!-- Mobile Question Selector -->
            <div class="lg:hidden mb-2">
              <div class="flex overflow-x-auto gap-1 pb-1.5 -mx-1 px-1">
                <ng-container
                  *ngFor="
                    let question of categories[i]?.questions;
                    let x = index
                  "
                >
                  <div
                    *ngIf="!isHiddenQuestion(i, x)"
                    (click)="directQuestion(x)"
                    class="flex-shrink-0 flex gap-0.5 cursor-pointer items-center px-1.5 py-0.5 rounded border transition-colors"
                    [ngClass]="{
                      'bg-[#043B22]/10 border-[#043B22]': x === currentQuestion,
                      'border-gray-200': x !== currentQuestion,
                    }"
                  >
                    <app-progress
                      *ngIf="!question.done && x === currentQuestion"
                    ></app-progress>
                    <app-done *ngIf="question.done"></app-done>
                    <app-todo
                      *ngIf="!question.done && x !== currentQuestion"
                    ></app-todo>
                    <div class="font-bold text-[14px]">
                      Q{{ visibleQuestionNumber(i, x) }}
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="flex flex-col lg:flex-row w-full gap-2 lg:gap-0">
              <!-- Question Sidebar - Hidden on mobile -->
              <div class="hidden lg:block lg:w-[18%] pr-3 py-1">
                <div class="flex flex-col gap-1.5 w-full">
                  <ng-container
                    *ngFor="
                      let question of categories[i]?.questions;
                      let x = index
                    "
                  >
                    <div
                      *ngIf="!isHiddenQuestion(i, x)"
                      (click)="directQuestion(x)"
                      class="flex gap-1.5 cursor-pointer items-center p-1.5 rounded transition-colors"
                      [ngClass]="
                        x === currentQuestion
                          ? 'bg-[#043B22]/10 border border-[#043B22]'
                          : 'hover:bg-gray-50'
                      "
                    >
                      <app-progress
                        *ngIf="!question.done && x === currentQuestion"
                      ></app-progress>
                      <app-done *ngIf="question.done"></app-done>
                      <app-todo
                        *ngIf="!question.done && x !== currentQuestion"
                      ></app-todo>
                      <div>
                        <div class="font-bold text-[14px]">
                          Q {{ visibleQuestionNumber(i, x) }}
                        </div>
                        <div class="text-[12px] text-[#616161] leading-tight">
                          {{ question?.title }}
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <!-- Main Question Content -->
              <div
                class="w-full lg:w-[60%] bg-white border border-gray-100 shadow-sm p-2 sm:p-3 rounded-lg mx-auto flex flex-col min-h-[420px]"
              >
                <div class="text-lg futura text-[#043B22]">
                  {{ categories[i].questions[currentQuestion].title }}
                </div>
                <div
                  class="text-[12px] sm:text-[12px] text-[#616161] my-1 mb-2"
                >
                  {{ categories[i].questions[currentQuestion].heading }}
                </div>
                <div class="flex-1">
                  <div *ngIf="currentCategory === 0">
                    <app-category1-question1
                      *ngIf="currentQuestion === 0"
                    ></app-category1-question1>
                    <app-category1-question2
                      *ngIf="currentQuestion === 1"
                    ></app-category1-question2>
                    <app-category1-question3
                      *ngIf="currentQuestion === 2"
                    ></app-category1-question3>
                    <app-category1-question4
                      *ngIf="currentQuestion === 3"
                    ></app-category1-question4>
                    <app-category1-question5
                      *ngIf="currentQuestion === 4"
                    ></app-category1-question5>
                    <app-category1-question6
                      *ngIf="currentQuestion === 5"
                    ></app-category1-question6>
                    <app-category1-question7
                      *ngIf="currentQuestion === 6"
                    ></app-category1-question7>
                    <app-category1-question8
                      *ngIf="currentQuestion === 7"
                    ></app-category1-question8>
                  </div>
                  <div *ngIf="currentCategory === 1">
                    <!-- <app-category2-question1 *ngIf="currentQuestion === 0"></app-category2-question1> Cat 2 Q1 removed per client request -->
                    <app-category2-question2
                      *ngIf="currentQuestion === 1"
                    ></app-category2-question2>
                    <app-category2-question3
                      *ngIf="currentQuestion === 2"
                    ></app-category2-question3>
                  </div>
                  <div *ngIf="currentCategory === 2">
                    <app-category3-question1
                      *ngIf="currentQuestion === 0"
                    ></app-category3-question1>
                    <app-category3-question2
                      *ngIf="currentQuestion === 1"
                    ></app-category3-question2>
                    <app-category3-question3
                      *ngIf="currentQuestion === 2"
                    ></app-category3-question3>
                    <!-- <app-category3-question3-4 *ngIf="currentQuestion === 2"></app-category3-question3-4> -->
                    <app-category3-question4
                      *ngIf="currentQuestion === 3"
                    ></app-category3-question4>
                    <app-category3-question5
                      *ngIf="currentQuestion === 4"
                    ></app-category3-question5>
                  </div>
                  <div *ngIf="currentCategory === 3">
                    <app-category4-question1
                      *ngIf="currentQuestion === 0"
                    ></app-category4-question1>
                    <app-category4-question2
                      *ngIf="currentQuestion === 1"
                    ></app-category4-question2>
                    <app-category4-question3
                      *ngIf="currentQuestion === 2"
                    ></app-category4-question3>
                    <app-category4-question4
                      *ngIf="currentQuestion === 3"
                    ></app-category4-question4>
                    <app-category4-question5
                      *ngIf="currentQuestion === 4"
                    ></app-category4-question5>
                  </div>
                  <div *ngIf="currentCategory === 4">
                    <app-category5-question1
                      *ngIf="currentQuestion === 0"
                    ></app-category5-question1>
                    <app-category5-question2
                      *ngIf="currentQuestion === 1"
                    ></app-category5-question2>
                    <app-category5-question3
                      *ngIf="currentQuestion === 2"
                    ></app-category5-question3>
                    <app-category5-question4
                      *ngIf="currentQuestion === 3"
                    ></app-category5-question4>
                  </div>
                  <div *ngIf="currentCategory === 5">
                    <app-category6-question1
                      *ngIf="currentQuestion === 0"
                    ></app-category6-question1>
                  </div>
                </div>
                <div
                  class="flex mt-auto pt-4 justify-between border-t border-gray-100"
                >
                  <div>
                    <app-button [onClick]="prevQuestion"
                      ><app-arrow-left></app-arrow-left
                    ></app-button>
                  </div>
                  <div>
                    <app-button [onClick]="nextQuestion"
                      ><app-arrow-right></app-arrow-right
                    ></app-button>
                  </div>
                </div>
              </div>
              <!-- Help/Doubts Sidebar - Hidden on mobile, shown on larger screens -->
              <div
                *ngIf="currentCategory < 6"
                class="hidden lg:flex flex-col gap-2 pl-2 w-full lg:w-[22%]"
              >
                <div
                  *ngIf="
                    !(
                      (currentCategory === 3 &&
                        (currentQuestion === 0 ||
                          currentQuestion === 1 ||
                          currentQuestion === 2)) ||
                      (currentCategory === 4 &&
                        (currentQuestion === 0 ||
                          currentQuestion === 1 ||
                          currentQuestion === 2 ||
                          currentQuestion === 3)) ||
                      (currentCategory === 5 && currentQuestion === 0)
                    )
                  "
                  class="bg-[#f8f9fa] border rounded border-[#043b22]/60 w-full p-2"
                >
                  <div
                    class="text-[#043b22] text-[14px] futura flex gap-1.5 items-center"
                  >
                    <app-question></app-question>
                    {{ locale.category.category_doubts }}
                  </div>
                  <div class="text-[#616161] text-[12px] mt-1 leading-relaxed">
                    {{ categories[i].questions[currentQuestion].doubt }}
                  </div>
                </div>
                <div
                  *ngIf="currentCategory === 3 && currentQuestion === 0"
                  class="bg-[#f8f9fa] border rounded border-[#043b22]/60 w-full p-2 relative"
                >
                  <div
                    class="text-[#043b22] text-[14px] futura flex gap-1.5 items-center"
                  >
                    <app-question></app-question>
                    <span>{{ locale.category.category_doubts }}</span>
                  </div>
                  <div class="text-[#616161] text-[12px] mt-1">
                    {{ strings[language].what_belongs_title }}
                    <span
                      (click)="toggleHelp($event)"
                      class="text-[#043b22] underline cursor-pointer font-medium"
                    >
                      <span *ngIf="!showHelp">{{
                        strings[language].read_more
                      }}</span>
                      <span *ngIf="showHelp">{{
                        strings[language].read_less
                      }}</span>
                    </span>
                  </div>
                  <div
                    *ngIf="showHelp"
                    class="absolute z-10 w-[240px] bg-white shadow-lg rounded p-2 border border-[#043b22]/60 text-[12px] right-0 mt-1"
                  >
                    <div class="p-2 rounded bg-[#043B22]/5 border mb-2">
                      <div class="flex items-center gap-1">
                        <img
                          src="images/arrow-right.svg"
                          alt=""
                          class="w-3 h-3"
                        />
                        <strong>{{
                          strings[language].what_belongs_title ||
                            'What belongs in "Purchased goods":'
                        }}</strong>
                      </div>
                      <div class="ml-4 mt-1 leading-relaxed">
                        {{ strings[language].what_belongs_1 }}<br />
                        • {{ strings[language].what_belongs_item1 }}<br />
                        • {{ strings[language].what_belongs_item2 }}<br />
                        • {{ strings[language].what_belongs_item3 }}<br />
                        • {{ strings[language].what_belongs_item4 }}<br />
                        • {{ strings[language].what_belongs_item5 }}
                      </div>
                      <div class="flex items-center gap-1 mt-2">
                        <img
                          src="images/arrow-right.svg"
                          alt=""
                          class="w-3 h-3"
                        />
                        <strong>{{
                          strings[language].do_not_include_title ||
                            'Do not include:'
                        }}</strong>
                      </div>
                      <div class="ml-4 mt-1 leading-relaxed">
                        • {{ strings[language].exclude_item1 }}<br />
                        • {{ strings[language].exclude_item2 }}<br />
                        • {{ strings[language].exclude_item3 }}<br />
                        • {{ strings[language].exclude_item4 }}<br />
                        • {{ strings[language].exclude_item5 }}
                      </div>
                    </div>
                    <div class="p-2 bg-[#043B22]/5 border rounded">
                      <div class="flex items-center gap-1">
                        <img
                          src="images/arrow-right.svg"
                          alt=""
                          class="w-3 h-3"
                        />
                        <strong>{{
                          strings[language].price_country_title ||
                            'Price and Country of production:'
                        }}</strong>
                      </div>
                      <div class="ml-4 mt-1 leading-relaxed">
                        <strong>{{
                          strings[language].price_note ||
                            'Price to enter = net invoice amount'
                        }}</strong
                        ><br />
                        ✓ {{ strings[language].include_discounts }}<br />
                        ✗ {{ strings[language].exclude_vat }}<br />
                        ✗ {{ strings[language].exclude_duties }}<br />
                        ✗ {{ strings[language].exclude_surcharges }}
                      </div>
                      <div class="ml-4 mt-2 leading-relaxed">
                        <strong>{{
                          strings[language].country_of_prod_title ||
                            'Country of production:'
                        }}</strong
                        ><br />
                        • {{ strings[language].country_known }}<br />
                        • {{ strings[language].country_unknown }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="currentCategory === 3 && currentQuestion === 1"
                  class="bg-[#f8f9fa] border rounded border-[#043b22]/60 w-full p-2 relative"
                >
                  <div
                    class="text-[#043b22] text-[14px] futura flex gap-1.5 items-center"
                  >
                    <app-question></app-question>
                    <span>{{ locale.category.category_doubts }}</span>
                  </div>
                  <div class="text-[#616161] text-[12px] mt-1">
                    {{ strings[language].what_belongs_titleq2 }}
                    <span
                      (click)="toggleHelp($event)"
                      class="text-[#043b22] underline cursor-pointer font-medium"
                    >
                      <span *ngIf="!showHelp">{{
                        strings[language].read_more
                      }}</span>
                      <span *ngIf="showHelp">{{
                        strings[language].read_less
                      }}</span>
                    </span>
                  </div>
                  <div
                    *ngIf="showHelp"
                    class="absolute z-10 w-[240px] bg-white shadow-lg rounded p-2 border border-[#043b22]/60 text-[12px] right-0 mt-1"
                  >
                    <div class="p-2 rounded bg-[#043B22]/5 border">
                      <div class="flex items-center gap-1">
                        <img
                          src="images/arrow-right.svg"
                          alt=""
                          class="w-3 h-3"
                        />
                        <strong>{{
                          strings[language].what_belongs_titleq2 ||
                            ' What belongs in "Capital goods":'
                        }}</strong>
                      </div>
                      <div class="ml-4 mt-1 leading-relaxed">
                        <div class="mb-1">
                          • {{ strings[language].what_belongs_item1q2 }}
                        </div>
                        <div>
                          • {{ strings[language].what_belongs_item2q2 }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="currentCategory === 3 && currentQuestion === 2"
                  class="bg-[#f8f9fa] border rounded border-[#043b22]/60 w-full p-2 relative"
                >
                  <div
                    class="text-[#043b22] text-[14px] futura flex gap-1.5 items-center"
                  >
                    <app-question></app-question>
                    <span>{{ locale.category.category_doubts }}</span>
                  </div>
                  <div class="text-[#616161] text-[12px] mt-1">
                    {{ strings[language].what_belongs_titleq3 }}
                    <span
                      (click)="toggleHelp($event)"
                      class="text-[#043b22] underline cursor-pointer font-medium"
                    >
                      <span *ngIf="!showHelp">{{
                        strings[language].read_more
                      }}</span>
                      <span *ngIf="showHelp">{{
                        strings[language].read_less
                      }}</span>
                    </span>
                  </div>
                  <div
                    *ngIf="showHelp"
                    class="absolute z-10 w-[240px] bg-white shadow-lg rounded p-2 border border-[#043b22]/60 text-[12px] right-0 mt-1"
                  >
                    <div class="space-y-2">
                      <div class="bg-[#043B22]/5 p-2 rounded border">
                        <p class="font-medium">
                          {{ strings[language].help_text2 }}
                        </p>
                        <p class="font-medium mt-1">
                          {{ strings[language].solid_waste_option }}
                        </p>
                        <ul class="list-disc pl-4 mt-1 leading-relaxed">
                          <li>
                            {{ strings[language].solid_waste_instructions1 }}
                          </li>
                          <li>
                            {{ strings[language].solid_waste_instructions2 }}
                          </li>
                          <li>
                            {{ strings[language].solid_waste_instructions3 }}
                          </li>
                          <li>
                            {{ strings[language].solid_waste_instructions4 }}
                          </li>
                        </ul>
                      </div>
                      <div class="bg-[#043B22]/5 p-2 rounded border">
                        <p class="font-medium">
                          {{ strings[language].wastewater_optionq3 }}
                        </p>
                        <ul class="list-disc pl-4 mt-1">
                          <li>
                            {{ strings[language].wastewater_instructions1 }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="currentCategory === 4 && currentQuestion === 0"
                  class="bg-[#f8f9fa] border rounded border-[#043b22]/60 w-full p-2 relative"
                >
                  <div
                    class="text-[#043b22] text-[14px] futura flex gap-1.5 items-center"
                  >
                    <app-question></app-question>
                    <span>{{ locale.category.category_doubts }}</span>
                  </div>
                  <div class="text-[#616161] text-[12px] mt-1">
                    {{ strings[language].what_belongs_titleC5q1 }}
                    <span
                      (click)="toggleHelp($event)"
                      class="text-[#043b22] underline cursor-pointer font-medium"
                    >
                      <span *ngIf="!showHelp">{{
                        strings[language].read_more
                      }}</span>
                      <span *ngIf="showHelp">{{
                        strings[language].read_less
                      }}</span>
                    </span>
                  </div>
                  <div
                    *ngIf="showHelp"
                    class="absolute z-10 w-[240px] bg-white shadow-lg rounded p-2 border border-[#043b22]/60 text-[12px] right-0 mt-1"
                  >
                    <div class="bg-[#043B22]/5 p-2 rounded border">
                      <ul class="list-disc pl-4 leading-relaxed space-y-1">
                        <li>{{ strings[language].helpBoxC5q1 }}</li>
                        <li>{{ strings[language].helpBox2C5q1 }}</li>
                        <li>
                          <b>{{ strings[language].helpBox3C5q1 }}:</b>
                          {{ strings[language].helpBox4C5q1 }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="currentCategory === 4 && currentQuestion === 1"
                  class="bg-[#f8f9fa] border rounded border-[#043b22]/60 w-full p-2 relative"
                >
                  <div
                    class="text-[#043b22] text-[14px] futura flex gap-1.5 items-center"
                  >
                    <app-question></app-question>
                    <span>{{ locale.category.category_doubts }}</span>
                  </div>
                  <div class="text-[#616161] text-[12px] mt-1">
                    {{ strings[language].what_belongs_titleC5q1 }}
                    <span
                      (click)="toggleHelp($event)"
                      class="text-[#043b22] underline cursor-pointer font-medium"
                    >
                      <span *ngIf="!showHelp">{{
                        strings[language].read_more
                      }}</span>
                      <span *ngIf="showHelp">{{
                        strings[language].read_less
                      }}</span>
                    </span>
                  </div>
                  <div
                    *ngIf="showHelp"
                    class="absolute z-10 w-[240px] bg-white shadow-lg rounded p-2 border border-[#043b22]/60 text-[12px] right-0 mt-1"
                  >
                    <div class="bg-[#043B22]/5 p-2 rounded border">
                      <ul class="list-disc pl-4">
                        <li>{{ strings[language].helpBoxC5q2 }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="currentCategory === 4 && currentQuestion === 2"
                  class="bg-[#f8f9fa] border rounded border-[#043b22]/60 w-full p-2 relative"
                >
                  <div
                    class="text-[#043b22] text-[14px] futura flex gap-1.5 items-center"
                  >
                    <app-question></app-question>
                    <span>{{ locale.category.category_doubts }}</span>
                  </div>
                  <div class="text-[#616161] text-[12px] mt-1">
                    {{ strings[language].what_belongs_titleC5q1 }}
                    <span
                      (click)="toggleHelp($event)"
                      class="text-[#043b22] underline cursor-pointer font-medium"
                    >
                      <span *ngIf="!showHelp">{{
                        strings[language].read_more
                      }}</span>
                      <span *ngIf="showHelp">{{
                        strings[language].read_less
                      }}</span>
                    </span>
                  </div>
                  <div
                    *ngIf="showHelp"
                    class="absolute z-10 w-[240px] bg-white shadow-lg rounded p-2 border border-[#043b22]/60 text-[12px] right-0 mt-1"
                  >
                    <div class="bg-[#043B22]/5 p-2 rounded border">
                      <ul class="list-disc pl-4 space-y-1 leading-relaxed">
                        <li>{{ strings[language].wasteInclusion }}</li>
                        <li>{{ strings[language].typicalRoutes }}</li>
                        <li>{{ strings[language].calculationRequirement }}</li>
                        <li>{{ strings[language].dataRequirements }}</li>
                        <li>{{ strings[language].exclusions }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="currentCategory === 4 && currentQuestion === 3"
                  class="bg-[#f8f9fa] border rounded border-[#043b22]/60 w-full p-2 relative"
                >
                  <div
                    class="text-[#043b22] text-[14px] futura flex gap-1.5 items-center"
                  >
                    <app-question></app-question>
                    <span>{{ locale.category.category_doubts }}</span>
                  </div>
                  <div class="text-[#616161] text-[12px] mt-1">
                    {{ strings[language].what_belongs_titleC5q1 }}
                    <span
                      (click)="toggleHelp($event)"
                      class="text-[#043b22] underline cursor-pointer font-medium"
                    >
                      <span *ngIf="!showHelp">{{
                        strings[language].read_more
                      }}</span>
                      <span *ngIf="showHelp">{{
                        strings[language].read_less
                      }}</span>
                    </span>
                  </div>
                  <div
                    *ngIf="showHelp"
                    class="absolute z-10 w-[240px] bg-white shadow-lg rounded p-2 border border-[#043b22]/60 text-[12px] right-0 mt-1"
                  >
                    <div class="bg-[#043B22]/5 p-2 rounded border">
                      <ul class="list-disc pl-4 space-y-1">
                        <li>{{ strings[language].includeFinancials }}</li>
                        <li>{{ strings[language].excludeFinancials }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="currentCategory === 5 && currentQuestion === 0"
                  class="bg-[#f8f9fa] border rounded border-[#043b22]/60 w-full p-2 relative"
                >
                  <div
                    class="text-[#043b22] text-[14px] futura flex gap-1.5 items-center"
                  >
                    <app-question></app-question>
                    <span>{{ locale.category.category_doubts }}</span>
                  </div>
                  <div class="text-[#616161] text-[12px] mt-1">
                    {{ strings[language].what_belongs_titleC5q1 }}
                    <span
                      (click)="toggleHelp($event)"
                      class="text-[#043b22] underline cursor-pointer font-medium"
                    >
                      <span *ngIf="!showHelp">{{
                        strings[language].read_more
                      }}</span>
                      <span *ngIf="showHelp">{{
                        strings[language].read_less
                      }}</span>
                    </span>
                  </div>
                  <div
                    *ngIf="showHelp"
                    class="absolute z-10 w-[240px] bg-white shadow-lg rounded p-2 border border-[#043b22]/60 text-[12px] right-0 mt-1 max-h-[300px] overflow-y-auto"
                  >
                    <div
                      class="bg-[#043B22]/5 p-2 rounded border leading-relaxed"
                    >
                      <p class="font-medium">
                        {{ strings[language].category6_title }}
                      </p>
                      <p class="mt-1">
                        {{ strings[language].category6_intro }}
                      </p>
                      <ul class="list-disc pl-4 mt-1">
                        <li
                          *ngFor="
                            let item of strings[language].category6_examples
                          "
                        >
                          {{ item }}
                        </li>
                      </ul>
                      <p class="mt-1">
                        {{ strings[language].category6_rule_of_thumb }}
                      </p>
                      <p class="font-medium mt-1">
                        {{ strings[language].category6_must_supply }}
                      </p>
                      <ol class="list-decimal pl-4 mt-1">
                        <li
                          *ngFor="
                            let item of strings[language].category6_supply_list
                          "
                        >
                          {{ item }}
                        </li>
                      </ol>
                      <p class="italic mt-1">
                        {{ strings[language].category6_avoid_double_counting }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="emissionFactor"
                  class="bg-[#f8f9fa] border rounded border-[#183A25]/60 w-full p-2"
                >
                  <div
                    class="text-[#183A25] text-[14px] futura flex gap-1.5 items-center"
                  >
                    <app-info></app-info>{{ locale.category.category_info }}
                  </div>
                  <div class="mt-1.5 space-y-1">
                    <div class="mt-1.5">
                      <div class="text-[12px] font-semibold">
                        {{ locale.category.heading_category }}
                      </div>
                      <div class="text-[12px]">
                        {{ emissionFactor.category }}
                      </div>
                    </div>
                    <div class="mt-1.5">
                      <div class="text-[12px] font-semibold">
                        {{ locale.category.info_name }}
                      </div>
                      <div class="text-[12px]">{{ emissionFactor.name }}</div>
                    </div>
                    <div class="mt-1.5">
                      <div class="text-[12px] font-semibold">
                        {{ locale.category.info_region }}
                      </div>
                      <div class="text-[12px]">{{ emissionFactor.region }}</div>
                    </div>
                    <div class="mt-1.5">
                      <div class="text-[12px] font-semibold">
                        {{ locale.category.info_source }}
                      </div>
                      <div class="text-[12px]">{{ emissionFactor.source }}</div>
                    </div>
                    <div class="mt-1.5">
                      <div class="text-[12px] font-semibold">
                        {{ locale.category.info_source_dataset }}
                      </div>
                      <div class="text-[12px]">
                        {{ emissionFactor.source_dataset }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w-full bg-white border border-gray-100 shadow-sm p-2 sm:p-3 rounded-lg m-auto"
        *ngIf="
          currentViewState === 'matrix' &&
          !(isInvitedUser && currentCategory >= 2)
        "
      >
        <div class="flex items-center justify-between gap-3">
          <div class="flex-1">
            <div
              class="font-bold text-[16px] sm:text-[18px] futura text-[#043B22]"
            >
              {{ locale.category.heading_category }} {{ currentCategory + 1 }}
            </div>
          </div>
          <div
            *ngIf="calculationName"
            class="flex-shrink-0 bg-[#043B22]/10 px-3 py-1.5 rounded-lg border border-[#043B22]/20"
          >
            <div class="text-[10px] text-[#616161] tracking-wide">
              {{ language === 'english' ? 'Calculation' : 'Calcolo' }}
            </div>
            <div
              class="text-[12px] sm:text-[13px] text-[#043B22] font-semibold"
              [title]="calculationName"
            >
              {{ calculationName }}
            </div>
          </div>
        </div>
        <div class="w-full bg-[#DFE7EF] h-px my-1.5 sm:my-2"></div>
        <div class="flex items-center gap-2 pb-1.5">
          <h1 class="text-[18px] futura text-[#043B22]">
            {{
              language === 'english'
                ? 'Significance Matrix'
                : 'Matrice di Significatività'
            }}
          </h1>
          <button
            (click)="openInfoModal('significance')"
            class="cursor-pointer p-1 hover:bg-[#043B22]/10 rounded-full transition-colors"
            title="Info"
          >
            <svg
              class="w-5 h-5 text-[#043B22]"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
          </button>
        </div>
        <div class="main-wrapper overflow-x-auto">
          <div class="Significance-Matrix min-w-[800px]">
            <table
              class="w-full border border-[#668e7c] rounded-lg overflow-hidden border-separate border-spacing-0"
            >
              <div class="table w-full text-left">
                <thead class="bg-[#043B22] text-white">
                  <tr>
                    <th
                      class="px-2 py-1.5 text-[14px] font-medium border border-[#668e7c]"
                      style="width:12%;"
                      *ngFor="let h of tableHeaders"
                    >
                      <ng-container *ngIf="h.tooltip; else plainHeader">
                        <div class="group relative inline-flex items-center">
                          <span
                            class="flex items-center gap-1 cursor-pointer"
                            (click)="$event.stopPropagation()"
                          >
                            {{ h.label }}
                            <img
                              class="w-3 h-3"
                              src="images/tooltip-icon.svg"
                              alt=""
                            />
                          </span>
                          <div
                            class="absolute left-full top-1/2 -translate-y-1/2 ml-1 hidden group-hover:block bg-white text-black text-[12px] px-1.5 py-0.5 rounded whitespace-nowrap z-50 shadow"
                          >
                            {{ h.tooltip }}
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #plainHeader>
                        <span>{{ h.label }}</span>
                      </ng-template>
                    </th>
                  </tr>
                </thead>
                <tbody class="text-[#212121]">
                  <tr class="text-[12px]" *ngFor="let row of significanceRows">
                    <td class="px-2 py-1.5 border-b border-r border-[#668e7c]">
                      <span>{{ row.elemento }}</span>
                    </td>
                    <td class="px-1.5 py-1 border-b border-r border-[#668e7c]">
                      <app-dropdown
                        class="cursor-pointer"
                        [placeholder]="strings[language].select_EN"
                        [options]="unitTypes"
                        [control]="row.form.controls.magnitude"
                        (change)="recalculateLS(row)"
                      ></app-dropdown>
                    </td>
                    <td class="px-1.5 py-1 border-b border-r border-[#668e7c]">
                      <app-dropdown
                        class="cursor-pointer"
                        [placeholder]="strings[language].select_INF"
                        [options]="unitTypes"
                        [control]="row.form.controls.influence"
                        (change)="recalculateLS(row)"
                      ></app-dropdown>
                    </td>
                    <td class="px-1.5 py-1 border-b border-r border-[#668e7c]">
                      <app-dropdown
                        class="cursor-pointer"
                        [placeholder]="strings[language].select_RIS_OPP"
                        [options]="unitTypes"
                        [control]="row.form.controls.riskOpportunity"
                        (change)="recalculateLS(row)"
                      ></app-dropdown>
                    </td>
                    <td class="px-1.5 py-1 border-b border-r border-[#668e7c]">
                      <app-dropdown
                        class="cursor-pointer"
                        [placeholder]="strings[language].select_IMP"
                        [options]="unitTypes"
                        [control]="row.form.controls.stakeholderEngagement"
                        (change)="recalculateLS(row)"
                      ></app-dropdown>
                    </td>
                    <td class="px-1.5 py-1 border-b border-r border-[#668e7c]">
                      <app-dropdown
                        class="cursor-pointer"
                        [placeholder]="strings[language].select_DD"
                        [options]="unitTypes"
                        [control]="row.form.controls.dataAccessibility"
                        (change)="recalculateLS(row)"
                      ></app-dropdown>
                    </td>
                    <td
                      class="px-2 py-1.5 border-b border-r border-[#668e7c] text-center"
                    >
                      {{ row.ls }}
                    </td>
                    <td
                      class="px-2 py-1.5 border-b border-r border-[#668e7c] align-middle"
                    >
                      <div class="flex items-center justify-center">
                        <label
                          class="inline-flex relative items-center cursor-pointer"
                        >
                          <input
                            type="checkbox"
                            class="sr-only peer"
                            [checked]="row.include"
                            (change)="toggleInclude(row)"
                          />
                          <div
                            class="w-8 h-4 bg-gray-300 rounded-full peer-checked:bg-[#709975] transition-colors"
                          ></div>
                          <div
                            class="absolute left-0.5 top-0.5 w-3 h-3 bg-white rounded-full shadow peer-checked:translate-x-4 transition-transform"
                          ></div>
                        </label>
                      </div>
                    </td>
                    <td class="px-2 py-1.5 border-b border-r border-[#668e7c]">
                      <div class="flex justify-center cursor-pointer">
                        <img
                          (click)="openModal(row)"
                          class="w-5 h-5"
                          src="images/edit-icon.svg"
                          alt=""
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </div>
            </table>
          </div>
        </div>
      </div>
      <div
        class="w-full bg-white border border-gray-100 shadow-sm p-2 sm:p-3 rounded-lg m-auto"
        *ngIf="
          currentViewState === 'matrix' &&
          !(isInvitedUser && currentCategory >= 2)
        "
      >
        <div class="flex items-center gap-2 pb-1.5">
          <h1 class="text-[18px] futura text-[#043B22]">
            {{
              language === 'english'
                ? 'Uncertainty Matrix'
                : 'Matrice di Incertezza'
            }}
          </h1>
          <button
            (click)="openInfoModal('uncertainty')"
            class="cursor-pointer p-1 hover:bg-[#043B22]/10 rounded-full transition-colors"
            title="Info"
          >
            <svg
              class="w-5 h-5 text-[#043B22]"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
          </button>
        </div>
        <div class="main-wrapper overflow-x-auto">
          <div class="Significance-Matrix min-w-[900px]">
            <table
              class="w-full border border-white rounded-lg overflow-hidden"
            >
              <thead class="bg-[#043B22] text-white text-[14px]">
                <tr>
                  <th class="px-2 py-1.5 border border-white w-[20%]">
                    {{ language === 'english' ? 'Element' : 'Elemento' }}
                  </th>
                  <th
                    colspan="2"
                    class="px-2 py-1.5 border border-white text-center w-[17%]"
                  >
                    {{
                      language === 'english'
                        ? 'Activity Data'
                        : 'Dati di Attività'
                    }}
                  </th>
                  <th
                    class="px-2 py-1.5 border border-white bg-[#709975] w-[10%]"
                  >
                    {{ language === 'english' ? 'Summary' : 'Riepilogo' }}
                  </th>
                  <th
                    colspan="2"
                    class="px-2 py-1.5 border border-white text-center w-[17%]"
                  >
                    {{
                      language === 'english'
                        ? 'Emission Factor'
                        : 'Fattore di Emissione'
                    }}
                  </th>
                  <th
                    class="px-2 py-1.5 border border-white bg-[#709975] w-[10%]"
                  >
                    {{ language === 'english' ? 'Summary' : 'Riepilogo' }}
                  </th>
                  <th
                    colspan="2"
                    class="px-2 py-1.5 border border-white text-center w-[16%]"
                  >
                    {{
                      language === 'english'
                        ? 'Results & Actions'
                        : 'Risultati e Azioni'
                    }}
                  </th>
                </tr>
              </thead>
              <tbody class="bg-[#F2F2F2] text-[#212121]">
                <ng-container *ngFor="let row of uncertaintyRows">
                  <!-- ROW 1 -->
                  <tr class="border border-white text-[12px]">
                    <!-- ELEMENT -->
                    <td
                      rowspan="3"
                      class="px-2 py-1.5 border border-white align-top"
                    >
                      <span class="font-bold text-[12px]">{{
                        row.elementLabel
                      }}</span>
                    </td>
                    <!-- AD : DAT -->
                    <td class="px-1.5 py-1 border border-white">
                      <ng-container
                        [ngTemplateOutlet]="tooltipTpl"
                        [ngTemplateOutletContext]="{
                          code: uncertaintyLabels.DAT,
                          tooltip: uncertaintyLabels.dataQuality,
                        }"
                      >
                      </ng-container>
                      <app-dropdown
                        [placeholder]="strings[language].select_DAT"
                        class="cursor-pointer"
                        [options]="scoreOptions"
                        [control]="row.activityDataForm.controls.data_quality"
                      >
                      </app-dropdown>
                    </td>
                    <!-- AD : REL -->
                    <td class="px-1.5 py-1 border border-white">
                      <ng-container
                        [ngTemplateOutlet]="tooltipTpl"
                        [ngTemplateOutletContext]="{
                          code: uncertaintyLabels.REL,
                          tooltip: uncertaintyLabels.relevance,
                        }"
                      ></ng-container>
                      <app-dropdown
                        [placeholder]="strings[language].select_REL"
                        class="cursor-pointer"
                        [options]="scoreOptions"
                        [control]="row.activityDataForm.controls.relevance"
                      >
                      </app-dropdown>
                    </td>
                    <!-- AD SUMMARY -->
                    <td
                      rowspan="3"
                      class="px-1.5 py-1 border border-white bg-[#70997533] text-center text-[12px]"
                    >
                      <div>{{ uncertaintyLabels.avg }}</div>
                      <div>{{ row.avgAD }}</div>
                      <div class="mt-2">{{ uncertaintyLabels.unc }}</div>
                      <div>±{{ row.uncADPercent }}%</div>
                    </td>
                    <!-- EF : DAT -->
                    <td class="px-1.5 py-1 border border-white">
                      <ng-container
                        [ngTemplateOutlet]="tooltipTpl"
                        [ngTemplateOutletContext]="{
                          code: uncertaintyLabels.DAT,
                          tooltip: uncertaintyLabels.dataQuality,
                        }"
                      ></ng-container>
                      <app-dropdown
                        [placeholder]="strings[language].select_DAT"
                        class="cursor-pointer"
                        [options]="scoreOptions"
                        [control]="row.emissionFactorForm.controls.data_quality"
                      >
                      </app-dropdown>
                    </td>
                    <!-- EF : REL -->
                    <td class="px-1.5 py-1 border border-white">
                      <ng-container
                        [ngTemplateOutlet]="tooltipTpl"
                        [ngTemplateOutletContext]="{
                          code: uncertaintyLabels.REL,
                          tooltip: uncertaintyLabels.relevance,
                        }"
                      ></ng-container>
                      <app-dropdown
                        [placeholder]="strings[language].select_REL"
                        class="cursor-pointer"
                        [options]="scoreOptions"
                        [control]="row.emissionFactorForm.controls.relevance"
                      >
                      </app-dropdown>
                    </td>
                    <!-- EF SUMMARY -->
                    <td
                      rowspan="3"
                      class="px-1.5 py-1 border border-white bg-[#70997533] text-center text-[12px]"
                    >
                      <div>{{ uncertaintyLabels.avg }}</div>
                      <div>{{ row.avgEF }}</div>
                      <div class="mt-2">{{ uncertaintyLabels.unc }}</div>
                      <div>±{{ row.uncEFPercent }}%</div>
                    </td>
                    <!-- RESULTS -->
                    <td
                      rowspan="3"
                      class="px-1.5 py-1 border border-white text-center text-[12px]"
                    >
                      <div class="font-medium">
                        {{ uncertaintyLabels.totalUnc }}
                      </div>
                      <div>±{{ row.totalUncertaintyPercent }}%</div>
                      <div
                        class="mt-3 cursor-pointer"
                        (click)="fileuploadModal(row)"
                      >
                        <div>{{ uncertaintyLabels.docs }}</div>
                        <div class="flex justify-center gap-1">
                          <span>{{ row.documents.length }}</span>
                          <img src="images/docs-icon.svg" class="w-4 h-4" />
                        </div>
                      </div>
                      <div
                        class="mt-3 cursor-pointer"
                        (click)="openNoteModal(row)"
                      >
                        <div>{{ uncertaintyLabels.note }}</div>
                        <div class="flex justify-center gap-1">
                          <span>{{ row.notes.length }}</span>
                          <img src="images/message-icon.svg" class="w-4 h-4" />
                        </div>
                      </div>
                    </td>
                    <!-- TOGGLE -->
                    <td
                      rowspan="3"
                      class="border border-white text-center w-[8%]"
                    >
                      <img
                        [src]="
                          row.expanded
                            ? 'images/up-toggle.svg'
                            : 'images/down-toggle.svg'
                        "
                        class="w-5 h-5 mx-auto cursor-pointer"
                        (click)="toggleRow(row)"
                      />
                    </td>
                  </tr>
                  <!-- ROW 2 -->
                  <tr class="border border-white text-[12px]">
                    <td class="px-1.5 py-1 border border-white">
                      <ng-container
                        [ngTemplateOutlet]="tooltipTpl"
                        [ngTemplateOutletContext]="{
                          code: uncertaintyLabels.TEM,
                          tooltip: uncertaintyLabels.temporal,
                        }"
                      ></ng-container>
                      <app-dropdown
                        [placeholder]="strings[language].select_TEM"
                        class="cursor-pointer"
                        [options]="scoreOptions"
                        [control]="
                          row.activityDataForm.controls.temporal_coverage
                        "
                      >
                      </app-dropdown>
                    </td>
                    <td class="px-1.5 py-1 border border-white">
                      <ng-container
                        [ngTemplateOutlet]="tooltipTpl"
                        [ngTemplateOutletContext]="{
                          code: uncertaintyLabels.GEO,
                          tooltip: uncertaintyLabels.geographical,
                        }"
                      ></ng-container>
                      <app-dropdown
                        [placeholder]="strings[language].select_GEO"
                        class="cursor-pointer"
                        [options]="scoreOptions"
                        [control]="
                          row.activityDataForm.controls.geographical_coverage
                        "
                      >
                      </app-dropdown>
                    </td>
                    <td class="px-1.5 py-1 border border-white">
                      <ng-container
                        [ngTemplateOutlet]="tooltipTpl"
                        [ngTemplateOutletContext]="{
                          code: uncertaintyLabels.TEM,
                          tooltip: uncertaintyLabels.temporal,
                        }"
                      ></ng-container>
                      <app-dropdown
                        [placeholder]="strings[language].select_TEM"
                        class="cursor-pointer"
                        [options]="scoreOptions"
                        [control]="
                          row.emissionFactorForm.controls.temporal_coverage
                        "
                      >
                      </app-dropdown>
                    </td>
                    <td class="px-1.5 py-1 border border-white">
                      <ng-container
                        [ngTemplateOutlet]="tooltipTpl"
                        [ngTemplateOutletContext]="{
                          code: uncertaintyLabels.GEO,
                          tooltip: uncertaintyLabels.geographical,
                        }"
                      ></ng-container>
                      <app-dropdown
                        [placeholder]="strings[language].select_GEO"
                        class="cursor-pointer"
                        [options]="scoreOptions"
                        [control]="
                          row.emissionFactorForm.controls.geographical_coverage
                        "
                      >
                      </app-dropdown>
                    </td>
                  </tr>
                  <!-- ROW 3 -->
                  <tr class="border border-white text-[12px]">
                    <td class="px-1.5 py-1 border border-white">
                      <ng-container
                        [ngTemplateOutlet]="tooltipTpl"
                        [ngTemplateOutletContext]="{
                          code: uncertaintyLabels.TEC,
                          tooltip: uncertaintyLabels.technological,
                        }"
                      ></ng-container>
                      <app-dropdown
                        [placeholder]="strings[language].select_TEC"
                        class="cursor-pointer"
                        [options]="scoreOptions"
                        [control]="
                          row.activityDataForm.controls.technological_coverage
                        "
                      >
                      </app-dropdown>
                    </td>
                    <td class="px-1.5 py-1 border border-white">
                      <ng-container
                        [ngTemplateOutlet]="tooltipTpl"
                        [ngTemplateOutletContext]="{
                          code: uncertaintyLabels.COM,
                          tooltip: uncertaintyLabels.completeness,
                        }"
                      ></ng-container>
                      <app-dropdown
                        [placeholder]="strings[language].select_COM"
                        class="cursor-pointer"
                        [options]="scoreOptions"
                        [control]="row.activityDataForm.controls.completeness"
                      >
                      </app-dropdown>
                    </td>
                    <td class="px-1.5 py-1 border border-white">
                      <ng-container
                        [ngTemplateOutlet]="tooltipTpl"
                        [ngTemplateOutletContext]="{
                          code: uncertaintyLabels.TEC,
                          tooltip: uncertaintyLabels.technological,
                        }"
                      ></ng-container>
                      <app-dropdown
                        [placeholder]="strings[language].select_TEC"
                        class="cursor-pointer"
                        [options]="scoreOptions"
                        [control]="
                          row.emissionFactorForm.controls.technological_coverage
                        "
                      >
                      </app-dropdown>
                    </td>
                    <td class="px-1.5 py-1 border border-white">
                      <ng-container
                        [ngTemplateOutlet]="tooltipTpl"
                        [ngTemplateOutletContext]="{
                          code: uncertaintyLabels.COM,
                          tooltip: uncertaintyLabels.completeness,
                        }"
                      ></ng-container>
                      <app-dropdown
                        [placeholder]="strings[language].select_COM"
                        class="cursor-pointer"
                        [options]="scoreOptions"
                        [control]="row.emissionFactorForm.controls.completeness"
                      >
                      </app-dropdown>
                    </td>
                  </tr>
                  <!-- ROW 4 -->
                  <tr *ngIf="row.expanded && row.climatiqResult">
                    <td colspan="9" class="bg-white px-4 py-3">
                      <div class="flex justify-between ">
                        <!-- Card 1 -->
                        <div class=" px-1 py-2 rounded-lg">
                          <div class="flex flex-col gap-1">
                            <h6
                              class="text-sm font-semibold uppercase text-gray-600"
                            >
                              Activity Data
                            </h6>
                            <h6 class="text-sm">
                              Quantity:<span class="font-medium text-black">
                                {{
                                  row.climatiqResult.activity_data
                                    .activity_value
                                }}
                                {{
                                  row.climatiqResult.activity_data.activity_unit
                                }}</span
                              >
                            </h6>
                            <!--h6 class="text-sm">Origin:<span class="font-medium text-black"> {{ row.climatiqResult.co2e_calculation_origin }}</span></h6-->
                            <h6 class="text-sm">
                              Origin:<span class="font-medium text-black">
                                Source</span
                              >
                            </h6>
                          </div>
                        </div>
                        <!-- Card 2 -->
                        <div class=" px-1 py-2 rounded-lg">
                          <div class="flex flex-col gap-1">
                            <h6
                              class="text-sm font-semibold uppercase text-gray-600"
                            >
                              EMISSION FACTOR
                            </h6>
                            <h6 class="text-sm">
                              Value:<span class="font-medium text-black">
                                {{
                                  (
                                    row.climatiqResult.co2e /
                                    row.climatiqResult.activity_data
                                      .activity_value
                                  ).toFixed(2)
                                }}{{ row.climatiqResult.co2e_unit }}/
                                {{
                                  row.climatiqResult.activity_data.activity_unit
                                }}</span
                              >
                            </h6>
                            <h6 class="text-sm">
                              Source:<span class="font-medium text-black">
                                {{
                                  row.climatiqResult.emission_factor.source
                                }}</span
                              >
                            </h6>
                            <h6 class="text-sm">
                              Dataset:<span class="font-medium text-black">
                                {{
                                  row.climatiqResult.emission_factor
                                    .source_dataset
                                }}</span
                              >
                            </h6>
                            <h6 class="text-sm">
                              Year:<span class="font-medium text-black">
                                {{
                                  row.climatiqResult.emission_factor.year
                                }}</span
                              >
                            </h6>
                            <h6 class="text-sm">
                              Region:<span class="font-medium text-black">
                                {{
                                  row.climatiqResult.emission_factor.region
                                }}</span
                              >
                            </h6>
                            <!--h6 class="text-sm">Activity ID:<span class="font-medium text-black"> {{ row.climatiqResult.emission_factor.activity_id }}</span></h6-->
                          </div>
                        </div>
                        <!-- Card 3 -->
                        <div class=" px-1 py-2 rounded-lg">
                          <div class="flex flex-col gap-1">
                            <h6
                              class="text-sm font-semibold uppercase text-gray-600"
                            >
                              EMISSION RESULT
                            </h6>
                            <h6 class="text-sm">
                              Emissions:<span class="font-medium text-black">
                                {{ row.climatiqResult.co2e }}
                                {{ row.climatiqResult.co2e_unit }}Co2e</span
                              >
                            </h6>
                            <h6 class="text-sm">
                              Method:<span class="font-medium text-black">
                                {{
                                  row.climatiqResult.co2e_calculation_method
                                }}</span
                              >
                            </h6>
                            <h6 class="text-sm">
                              Status:<span class="font-medium text-black"
                                >Calculated</span
                              >
                            </h6>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
              <!-- REUSABLE TOOLTIP TEMPLATE -->
              <ng-template #tooltipTpl let-code="code" let-tooltip="tooltip">
                <div
                  class="flex items-center gap-2 relative group mb-1 text-[12px]"
                >
                  {{ code }}
                  <img src="images/info-icon.svg" class="w-[12px] h-[12px]" />
                  <div
                    class="absolute left-full top-1/2 -translate-y-1/2 ml-2 hidden group-hover:block
                        bg-black text-white text-xs px-2 py-1 rounded whitespace-nowrap z-50"
                  >
                    {{ tooltip }}
                  </div>
                </div>
              </ng-template>
            </table>
          </div>
        </div>
        <div class="flex mt-8 justify-between gap-3 w-full">
          <div>
            <app-button [onClick]="prevQuestion">
              <app-arrow-left></app-arrow-left>
            </app-button>
          </div>
          <div>
            <app-button [onClick]="nextQuestion">
              <app-arrow-right></app-arrow-right>
            </app-button>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          currentViewState === 'stepCompleted' &&
          !(isInvitedUser && currentCategory >= 2)
        "
        class="w-[80%] bg-white border border-gray-100 shadow-sm p-3 rounded-lg m-auto"
      >
        <div class="flex items-center justify-between gap-3">
          <div class="flex-1">
            <div
              class="font-bold text-[16px] sm:text-[18px] futura text-[#043B22]"
            >
              {{ locale.category.heading_category }} {{ currentCategory + 1 }}
            </div>
          </div>
          <div
            *ngIf="calculationName"
            class="flex-shrink-0 bg-[#043B22]/10 px-3 py-1.5 rounded-lg border border-[#043B22]/20"
          >
            <div class="text-[10px] text-[#616161] tracking-wide">
              {{ language === 'english' ? 'Calculation' : 'Calcolo' }}
            </div>
            <div
              class="text-[12px] sm:text-[13px] text-[#043B22] font-semibold"
              [title]="calculationName"
            >
              {{ calculationName }}
            </div>
          </div>
        </div>
        <div class="text-[16px] futura text-[#043B22]">
          {{ locale.category.heading_steps_completed }}
        </div>
        <p class="mt-1 text-[12px] sm:text-[12px] text-[#616161]">
          {{ locale.category.subheading_steps_completed }}
        </p>
        <div
          class="mt-2 sm:mt-3 grid grid-cols-2 lg:grid-cols-4 gap-1.5 sm:gap-2"
        >
          <div
            class="bg-[#183A25]/40 min-h-34 sm:min-h-38 h-fit p-1.5 rounded-lg"
          >
            <div
              class="rounded-full h-7 w-7 sm:h-8 sm:w-8 bg-[#183A25]/40 mx-auto mt-1.5 flex justify-center items-center"
            >
              <app-map></app-map>
            </div>
            <div class="mx-auto items-center mt-1.5 text-white/60 text-center">
              CH<sub>4</sub>
              <div
                class="text-white text-[12px] mt-0.5 break-words font-medium"
              >
                {{ totalCh4_t.toFixed(3) }}
              </div>
              <div class="text-white text-[12px] sm:text-[12px]">t</div>
            </div>
          </div>
          <div
            class="bg-[#043b22]/80 min-h-34 sm:min-h-38 h-fit p-1.5 rounded-lg"
          >
            <div
              class="rounded-full h-7 w-7 sm:h-8 sm:w-8 bg-[#043b22]/80 mx-auto mt-1.5 flex justify-center items-center"
            >
              <app-inbox></app-inbox>
            </div>
            <div
              class="mx-auto items-center mt-1.5 text-[14px] text-white/80 text-center"
            >
              CO2
              <div
                class="text-white text-[12px] mt-0.5 break-words font-medium"
              >
                {{ totalCo2_t.toFixed(3) }}
              </div>
              <div class="text-white text-[12px] sm:text-[12px]">t</div>
            </div>
          </div>
          <div
            class="bg-[#043b22]/80 min-h-34 sm:min-h-38 h-fit p-1.5 rounded-lg"
          >
            <div
              class="rounded-full h-7 w-7 sm:h-8 sm:w-8 bg-[#043b22]/80 mx-auto mt-1.5 flex justify-center items-center"
            >
              <app-inbox></app-inbox>
            </div>
            <div
              class="mx-auto items-center mt-1.5 text-[14px] text-white/80 text-center"
            >
              CO<sub>2e</sub>
              <div
                class="text-white text-[12px] mt-0.5 break-words font-medium"
              >
                {{ totalCo2e_t.toFixed(3) }}
              </div>
              <div class="text-white text-[12px] sm:text-[12px]">t</div>
            </div>
          </div>
          <div
            class="bg-[#183A25]/40 min-h-34 sm:min-h-38 h-fit p-1.5 rounded-lg"
          >
            <div
              class="rounded-full h-7 w-7 sm:h-8 sm:w-8 bg-[#183A25]/40 mx-auto mt-1.5 flex justify-center items-center"
            >
              <app-map></app-map>
            </div>
            <div class="mx-auto items-center mt-1.5 text-white/60 text-center">
              N<sub>2</sub>O
              <div
                class="text-white text-[12px] mt-0.5 break-words font-medium"
              >
                {{ totalN2O_t.toFixed(3) }}
              </div>
              <div class="text-white text-[12px] sm:text-[12px]">t</div>
            </div>
          </div>
        </div>
        <div class="flex mt-3 justify-between w-full">
          <div>
            <app-button [onClick]="prevQuestion"
              ><app-arrow-left></app-arrow-left
            ></app-button>
          </div>
          <div>
            <app-button [onClick]="nextQuestion"
              ><app-arrow-right></app-arrow-right
            ></app-button>
          </div>
        </div>
      </div>
      <div *ngIf="currentViewState === 'summary'">
        <app-calculation-summary
          [categoryCompleted]="currentViewState === 'summary'"
          [currentCategory]="currentCategory"
          [currentQuestion]="currentQuestion"
          [categories]="categories"
          [locale]="locale"
          [setQuestion]="setQuestion"
        ></app-calculation-summary>
      </div>
    </div>
    <!-- notes popup model -->
    <div
      *ngIf="isModalOpen"
      class="fixed inset-0 bg-black/50 flex items-center justify-center p-3 z-50"
    >
      <div class="bg-white p-2.5 sm:p-3 rounded-lg w-full max-w-lg">
        <div class="popup flex flex-col gap-2">
          <div class="flex justify-between items-center">
            <h4 class="text-[16px] font-semibold text-[#043B22]">Note</h4>
            <button
              (click)="isModalOpen = false"
              class="cursor-pointer p-0.5 hover:bg-gray-100 rounded transition-colors"
            >
              <img src="images/close-btn.svg" alt="" class="w-4 h-4" />
            </button>
          </div>
          <textarea
            class="text-left border border-[#cccccc] rounded p-2 h-[80px] sm:h-[100px] text-[12px] focus:outline-none focus:border-[#043B22]"
            placeholder="Enter text here ..."
            *ngIf="activeSignificanceRow"
            [(ngModel)]="activeSignificanceRow.comment"
          ></textarea>
          <span class="flex justify-end">
            <button
              class="text-[12px] sm:text-[12px] text-white bg-[#043B22] rounded px-3 py-1.5 cursor-pointer hover:bg-[#043B22]/90 transition-colors"
              (click)="saveComment()"
            >
              Save
            </button>
          </span>
        </div>
      </div>
    </div>
    <!-- uncertinity docs model -->
    <div
      *ngIf="isuploadModalOpen"
      class="fixed inset-0 bg-black/50 flex items-center justify-center p-3 z-50 overflow-y-auto"
    >
      <div class="bg-white p-2.5 sm:p-3 rounded-lg w-full max-w-xl my-auto">
        <div class="popup flex flex-col gap-1.5">
          <div class="flex justify-between items-center">
            <h4 class="text-[16px] font-semibold text-[#043B22]">
              File Upload
            </h4>
            <button
              (click)="closeUploadModal()"
              class="cursor-pointer p-0.5 hover:bg-gray-100 rounded transition-colors"
            >
              <img src="images/close-btn.svg" alt="" class="w-4 h-4" />
            </button>
          </div>
          <p class="text-[12px] text-[#979797]">
            Add your documents here, up to 10 files max
          </p>
          <div
            class="upload-box flex text-center items-center flex-col border p-2 sm:p-3 border-dashed border-[#709975] rounded gap-1.5"
            (dragover)="onDragOver($event)"
            (drop)="onDrop($event)"
          >
            <img
              class="w-5 h-5 sm:w-6 sm:h-6"
              src="images/upload-icon.svg"
              alt=""
            />
            <p class="text-[12px] sm:text-[12px]">Drag files to upload</p>
            <p class="text-[12px] text-[#616161]">--- OR ---</p>
            <span class="flex justify-center">
              <label
                for="uncertaintyFileInput"
                class="text-[12px] sm:text-[12px] text-[#043B22] border font-medium border-[#043B22] rounded px-2 py-1 cursor-pointer hover:bg-[#043B22]/5 transition-colors"
                >Browse files</label
              >
              <input
                id="uncertaintyFileInput"
                accept=".pdf,.jpg,.png,.svg,.zip,.xls,.xlsx"
                type="file"
                multiple
                hidden
                (change)="onFilesSelected($event)"
              />
            </span>
          </div>
          <p class="text-[12px] text-[#979797]">
            Supports .jpg, .png, .svg, .zip files
          </p>
          <div
            class="grid grid-cols-2 sm:grid-cols-3 gap-1.5"
            *ngIf="activeUncertaintyRow"
          >
            <div *ngFor="let file of activeUncertaintyRow.documents">
              <div
                class="flex items-center justify-between border border-[#cccccc] gap-1 p-1.5 rounded"
              >
                <div class="flex gap-1 items-center">
                  <img
                    class="w-4 h-4 sm:w-5 sm:h-5"
                    src="images/file-icon.svg"
                    alt=""
                  />
                  <span
                    class="text-[12px] text-[#979797] max-w-[80px] sm:max-w-[100px] truncate cursor-pointer hover:text-[#043B22]"
                    (click)="openFile(file)"
                    >{{ file.filename }}</span
                  >
                </div>
                <img
                  class="w-3 h-3 cursor-pointer hover:opacity-70"
                  src="images/asset-close.svg"
                  alt=""
                  (click)="removeFile(file.file_id)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- uncertinity notes model -->
    <div
      *ngIf="isNoteModalOpen"
      class="fixed inset-0 bg-black/50 flex items-center justify-center p-3 z-50 overflow-y-auto"
    >
      <div class="bg-white p-2.5 sm:p-3 rounded-lg w-full max-w-lg my-auto">
        <div class="flex flex-col gap-2">
          <div class="flex justify-between items-center">
            <h4 class="text-[12px] font-semibold text-[#043B22]">Notes</h4>
            <button
              (click)="closeNoteModal()"
              class="cursor-pointer p-0.5 hover:bg-gray-100 rounded transition-colors"
            >
              <img class="w-4 h-4" src="images/close-btn.svg" />
            </button>
          </div>
          <!-- Existing notes -->
          <div
            class="flex flex-col max-h-[120px] overflow-auto gap-1.5"
            style="scrollbar-width: thin;"
          >
            <div class="flex flex-col justify-between gap-1.5">
              <div
                *ngFor="let note of activeNoteRow?.notes"
                class="w-full flex justify-between text-[12px] sm:text-[12px] border border-[#cccccc] rounded p-2"
              >
                <div class="flex-1 pr-2">
                  {{ note.text
                  }}<span class="block text-[12px] text-gray-400 mt-0.5">{{
                    note.createdAt | date: 'medium'
                  }}</span>
                </div>
                <img
                  class="cursor-pointer w-3 h-3 flex-shrink-0 hover:opacity-70"
                  src="images/input-close.svg"
                  (click)="confirmDeleteNote(note.id)"
                />
              </div>
            </div>
            <p
              *ngIf="activeNoteRow && activeNoteRow.notes.length === 0"
              class="text-[12px] text-gray-400"
            >
              No notes yet.
            </p>
          </div>
          <!-- New note -->
          <textarea
            class="border border-[#cccccc] rounded p-2 h-[70px] sm:h-[80px] text-[12px] focus:outline-none focus:border-[#043B22]"
            placeholder="Enter note here..."
            [(ngModel)]="newNoteText"
          ></textarea>
          <!-- Save -->
          <span class="flex justify-end">
            <button
              class="text-[12px] sm:text-[12px] text-white bg-[#043B22] rounded px-3 py-1.5 cursor-pointer hover:bg-[#043B22]/90 transition-colors"
              (click)="saveNote()"
            >
              Save
            </button>
          </span>
        </div>
      </div>
    </div>
    <!-- Delete Note Confirmation Modal -->
    <div
      *ngIf="isDeleteNoteModalOpen"
      class="fixed inset-0 bg-black/50 flex items-center justify-center p-3 z-50"
    >
      <div class="bg-white p-2.5 sm:p-3 rounded-lg w-full max-w-xs">
        <div class="flex flex-col gap-2">
          <h4 class="text-[12px] font-semibold text-[#043B22]">Delete Note</h4>
          <p class="text-[12px] sm:text-[12px] text-[#616161]">
            Are you sure you want to delete this note?
          </p>
          <div class="flex justify-end gap-1.5">
            <button
              class="px-2.5 py-1 text-[12px] sm:text-[12px] rounded border border-gray-300 text-gray-600 cursor-pointer hover:bg-gray-50 transition-colors"
              (click)="cancelDeleteNote()"
            >
              Cancel
            </button>
            <button
              class="px-2.5 py-1 text-[12px] sm:text-[12px] rounded bg-[#043B22] text-white cursor-pointer hover:bg-[#043B22]/90 transition-colors"
              (click)="deleteNoteConfirmed()"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Info Modal for Significance/Uncertainty Matrix -->
    <div
      *ngIf="isInfoModalOpen"
      class="fixed inset-0 bg-black/50 flex items-center justify-center p-3 z-50"
    >
      <div class="rounded-lg w-full max-w-3xl max-h-[85vh] flex flex-col">
        <div
          class="bg-[#043B22] flex justify-between items-center p-4 sm:p-5 border-b border-gray-200 sticky top-0 z-10 rounded-t-lg"
        >
          <h4 class="text-[16px] font-semibold text-white">
            {{ infoModalTitle }}
          </h4>
          <button
            (click)="closeInfoModal()"
            class="cursor-pointer text-white p-1 bg-gray-100 rounded-full transition-colors"
          >
            <img src="images/close-btn.svg" alt="Close" class="w-4 h-4" />
          </button>
        </div>
        <div
          class="bg-white p-4 sm:p-5 overflow-y-auto flex-1 text-[13px] text-[#333333] leading-relaxed info-modal-content"
          [innerHTML]="infoModalContent"
        ></div>
      </div>
    </div>
  `,
})
export class CalculationCategoriesComponent {
  @ViewChild('fileInput', { static: false })
  fileInput!: ElementRef<HTMLInputElement>;
  api = inject(APIService);
  climatiq = inject(ClimatiqService);
  localeService = inject(LocaleService);
  categoryService = inject(CategoryService);
  private inviteServiceRef = inject(InviteService);
  private userServiceRef = inject(UserService);
  isInvitedUser = localStorage.getItem('isInvitedUser') === 'true';
  inviteRecord: InviteRecord | null = null;
  locale = this.localeService.locale();
  categories = this.categoryService.categories();
  currentCategory = 0;
  currentQuestion = 0;
  currentViewState: ViewState = 'question';
  calculationName: string = '';
  isDeleteNoteModalOpen = false;
  noteToDeleteId: string | null = null;
  showHelp: boolean = false;
  isInfoModalOpen: boolean = false;
  infoModalTitle: string = '';
  infoModalContent: string = '';
  language = inject(LocaleService).getLanguage();
  totalCh4 = 0;
  totalCo2 = 0;
  totalN2O = 0;
  totalCo2e = 0;
  isModalOpen: boolean = false;
  emissionFactor: any = {
    category: '',
    name: '',
    region: '',
    source: '',
    source_dataset: '',
  };
  unitTypes = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
  ];
  constructor(private currentCat: SharedStateService) {
    this.currentCat.currentCat$.subscribe((data) => {
      this.currentCategory = data;
      // Cat 2 Q1 is hidden — start at index 1; all other categories start at 0
      this.currentQuestion = data === 1 ? 1 : 0;
    });
    this.currentCat.viewState$.subscribe((state) => {
      this.currentViewState = state;
    });
    effect(() => {
      this.locale = this.localeService.locale();
      this.categories = this.categoryService.categories();

      // Invited users with active subscription get full access
      const user = this.userServiceRef.user();
      this.isInvitedUser =
        localStorage.getItem('isInvitedUser') === 'true' &&
        !user?.subscriptionPlan;
    });

    // Load invite record for status auto-updates
    if (this.isInvitedUser) {
      this.loadInviteRecord();
    }
  }

  private async loadInviteRecord(): Promise<void> {
    try {
      const { fetchUserAttributes } = await import('aws-amplify/auth');
      const attrs = await fetchUserAttributes();
      const email = (attrs.email || '').trim().toLowerCase();
      if (email) {
        const invites = await this.inviteServiceRef.loadInvitesForEmail(email);
        // Get the most recent invite with status 'registered' or 'started'
        this.inviteRecord =
          invites.find(
            (inv) =>
              inv.status === 'registered' ||
              inv.status === 'started' ||
              inv.status === 'invited',
          ) || null;
      }
    } catch (error) {
      console.error('Error loading invite record:', error);
    }
  }

  strings: any = {
    english: {
      select_EN: 'Select EN',
      select_INF: 'Select INF',
      select_RIS_OPP: 'Select RIS/OPP',
      select_IMP: 'Select IMP',
      select_DD: 'Select DD',
      select_DAT: 'Select DAT',
      select_REL: 'Select REL',
      select_TEM: 'Select TEM',
      select_GEO: 'Select GEO',
      select_TEC: 'Select TEC',
      select_COM: 'Select COM',
      read_more: 'read more...',
      read_less: 'read less',
      selectUnit: '2',
      what_belongs_title: 'What belongs in “Purchased goods”:',
      what_belongs_1: 'Add these day-to-day, short-lived items:',
      what_belongs_item1: 'Raw materials and ingredients',
      what_belongs_item2: 'Packaging (boxes, pallets, labels, etc.)',
      what_belongs_item3: 'Spare parts and maintenance consumables',
      what_belongs_item4: 'Office supplies (paper, toner, pens …)',
      what_belongs_item5:
        'Canteen food and other consumables used up this year',
      do_not_include_title: 'Do not include:',
      exclude_item1: 'Capital assets: machines, vehicles, buildings',
      exclude_item2: 'Energy: fuels, electricity, steam, heat',
      exclude_item3: 'Freight or delivery charges',
      exclude_item4: 'Waste-management fees',
      exclude_item5:
        'Pure services (consulting, software licences, cleaning, insurance, subcontracted labour)',
      price_country_title: 'Price and Country of production:',
      price_note: 'Price to enter = net invoice amount',
      include_discounts: 'Include on-invoice discounts or rebates',
      exclude_vat: 'Exclude VAT and other sales taxes',
      exclude_duties: 'Exclude customs duties',
      exclude_surcharges:
        'Exclude freight, insurance, or other surcharges shown as separate lines',
      country_of_prod_title: 'Country of production:',
      country_known:
        'Choose the country where the product was made if you know it.',
      country_unknown:
        'If you don’t know, use the country where you acquired it.',
      what_belongs_titleq2: 'What belongs in “Capital goods” :',
      what_belongs_item1q2:
        ' Include : production machinery, vehicles, buildings & major renovations, HVAC/solar, servers furniture, lab/medical equipment.',
      what_belongs_item2q2:
        ' Exclude : consumables, routine spare parts, energy, freight, pure services and leased assets.',
      help_text2: 'How to complete this section',
      solid_waste_option: 'Solid & sludge waste',
      wastewater_option: 'Waste-water & effluents',
      wastewater_instructions:
        'Enter the amount paid to your water utility or contractor for waste-water treatment during the chosen reporting period.',
      solid_waste_instructions1:
        'Select a category (e.g. plastics, construction).',
      solid_waste_instructions2: 'Choose material & treatment.',
      solid_waste_instructions3:
        'Enter quantity, unit (kg or t), and reporting period (YYYY).',
      solid_waste_instructions4:
        'Material & treatment options appear only after selecting a category.',
      what_belongs_titleq3: 'How to complete this section Solid & sludge waste',
      what_belongs_titleC5q1: 'How to complete this section',
      wastewater_optionq3: 'Waste-water & effluents',
      wastewater_instructions1:
        'Enter the amount spent, currency, and reporting period (YYYY).',
      helpBoxC5q1:
        'Report emissions from products your organization sold that consume energy (like cars or electronics), are fuels themselves (like gasoline), or release greenhouse gases during use (like refrigerants).',
      helpBox2C5q1:
        'Do not include emissions from manufacturing, disposal, or from products with no significant energy impact during use (like furniture or clothing).',
      helpBox3C5q1: 'Select the calculation methods',
      helpBox4C5q1:
        'You may choose one or more methods (M1–M5) based on the characteristics of the products. The methods are not mutually exclusive and can be combined.',
      wasteInclusion:
        'Include all products and packaging that become waste once customers finish using them.',
      typicalRoutes:
        'Typical routes: landfill, incineration (with or without energy recovery), mechanical or chemical recycling, composting, anaerobic digestion, take-back schemes, etc.',
      calculationRequirement:
        'The calculation must cover the total expected emissions from these treatments, even if they occur in future years — as required by Scope 3 Category 12 of the GHG Protocol Chapter 12.',
      dataRequirements:
        'You will need: (1) the total mass of products + packaging sold, and (2) the percentage share going to each treatment method.',
      exclusions:
        'Exclude services, digital products, or emissions already reported in manufacturing, use-phase, or other categories.',
      includeFinancials:
        'Include: listed equity & corporate bonds, corporate loans, project-finance positions.',
      excludeFinancials:
        'Exclude: treasury cash, derivatives, or any holding already consolidated in scopes 1-2 via equity-share or control approaches.',
      helpBoxC5q2:
        ' If you recognise the asset’s energy in your own Scope 1 or 2, stop here – do not use Category 5.2 to avoid double counting.',
      category6_title: 'What goes in Category 6?',
      category6_intro:
        'Use this section only for indirect GHG sources or sinks that do not logically belong in Categories 3 to 5. Typical examples include:',
      category6_examples: [
        'Contracted data-centre electricity outside your energy purchase agreements.',
        'GHG releases from outsourced R&D test rigs located at partner sites.',
        'One-off land-use-change emissions tied to special real-estate projects.',
        'Fugitive refrigerant leaks from short-term exhibition equipment you do not operate.',
      ],
      category6_rule_of_thumb:
        'Rule of thumb: If an emission is outside your direct (Scope 1) or imported-energy (Scope 2) boundaries and cannot be placed in Categories 3–5, record it here.',
      category6_must_supply: 'Information you must supply',
      category6_supply_list: [
        'Plain-language description of the source.',
        'Activity data (e.g., kWh, t km, kg of material).',
        'Emission factor – pick one from the built-in factor library or enter a documented custom factor.',
        'Justification explaining why the source belongs in Category 6 and how the factor was chosen.',
      ],
      category6_avoid_double_counting:
        'Avoid double counting: If the description overlaps with something you have already entered elsewhere, revisit those earlier categories first.',
    },
    italian: {
      select_EN: 'Seleziona EN',
      select_INF: 'Seleziona INF',
      select_RIS_OPP: 'Seleziona RIS/OPP',
      select_IMP: 'Seleziona IMP',
      select_DD: 'Seleziona DD',
      select_DAT: 'Seleziona DAT',
      select_REL: 'Seleziona REL',
      select_TEM: 'Seleziona TEM',
      select_GEO: 'Seleziona GEO',
      select_TEC: 'Seleziona TEC',
      select_COM: 'Seleziona COM',
      read_more: 'leggi di più...',
      read_less: 'leggi meno',
      what_belongs_title: 'Cosa rientra nei "Beni acquistati":',
      what_belongs_1:
        'Includere questi articoli di uso quotidiano e breve durata:',
      what_belongs_item1: 'Materie prime e ingredienti',
      what_belongs_item2: 'Imballaggi (scatole, pallet, etichette, ecc.)',
      what_belongs_item3:
        'Parti di ricambio e materiali di consumo per la manutenzione',
      what_belongs_item4: 'Forniture per ufficio (carta, toner, penne …)',
      what_belongs_item5:
        'Cibo della mensa e altri consumabili utilizzati durante l’anno',
      do_not_include_title: 'Non includere:',
      exclude_item1: 'Beni capitali: macchinari, veicoli, edifici',
      exclude_item2: 'Energia: combustibili, elettricità, vapore, calore',
      exclude_item3: 'Costi di trasporto o consegna',
      exclude_item4: 'Spese di gestione dei rifiuti',
      exclude_item5:
        'Servizi puri (consulenza, licenze software, pulizia, assicurazione, manodopera esternalizzata)',
      price_country_title: 'Prezzo e Paese di produzione:',
      price_note: 'Prezzo da inserire = importo netto della fattura',
      include_discounts: 'Includere sconti o rimborsi presenti in fattura',
      exclude_vat: 'Escludere IVA e altre imposte sulle vendite',
      exclude_duties: 'Escludere dazi doganali',
      exclude_surcharges:
        'Escludere spese di trasporto, assicurazione o altri supplementi indicati separatamente',
      country_of_prod_title: 'Paese di produzione:',
      country_known:
        'Scegliere il paese in cui è stato prodotto il bene, se noto.',
      country_unknown:
        'Se non lo si conosce, utilizzare il paese in cui è stato acquisito.',
      what_belongs_titleq2: 'Cosa rientra nei “Beni capitali”:',
      what_belongs_item1q2:
        ' Includere: macchinari di produzione, veicoli, edifici e grandi ristrutturazioni, HVAC/impianti solari, server, mobili, apparecchiature di laboratorio/mediche.',
      what_belongs_item2q2:
        ' Escludere: materiali di consumo, pezzi di ricambio ordinari, energia, trasporti, servizi puri e beni in leasing.',
      help_text2: 'Come completare questa sezione',
      solid_waste_option: 'Rifiuti solidi e fangosi',
      wastewater_option: 'Acque reflue e effluenti',
      wastewater_instructions:
        "Inserire l'importo pagato alla vostra utility idrica o all'appaltatore per il trattamento delle acque reflue durante il periodo di rendicontazione scelto.",
      solid_waste_instructions1:
        'Seleziona una categoria (es. plastica, edilizia).',
      solid_waste_instructions2: 'Scegli materiale e trattamento.',
      solid_waste_instructions3:
        'Inserisci quantità, unità (kg o t) e periodo di rendicontazione (AAAA).',
      solid_waste_instructions4:
        'Le opzioni materiale e trattamento appaiono solo dopo aver selezionato una categoria.',
      what_belongs_titleq3:
        'Come compilare questa sezione: Rifiuti solidi e fanghi',
      what_belongs_titleC5q1: 'Come completare questa sezione',
      wastewater_optionq3: 'Acque reflue e effluenti',
      wastewater_instructions1:
        "Inserisci l'importo speso, valuta e periodo di rendicontazione (AAAA).",
      helpBoxC5q1:
        'Riporta le emissioni derivanti dai prodotti venduti dalla tua organizzazione che consumano energia (come automobili o dispositivi elettronici), sono essi stessi combustibili (come la benzina) o rilasciano gas serra durante l’uso (come i refrigeranti).',
      helpBox2C5q1:
        'Non includere le emissioni derivanti dalla produzione, dallo smaltimento o dai prodotti che non hanno un impatto energetico significativo durante l’uso (come i mobili o l’abbigliamento).',
      helpBox3C5q1: 'Selezionare i metodi di calcolo',
      helpBox4C5q1:
        'È possibile scegliere uno o più metodi (M1–M5) in base alle caratteristiche dei prodotti. I metodi non si escludono a vicenda e possono essere combinati.',
      wasteInclusion:
        'Includere tutti i prodotti e gli imballaggi che diventano rifiuti una volta che i clienti li hanno utilizzati.',
      typicalRoutes:
        'Percorsi tipici: discarica, incenerimento (con o senza recupero energetico), riciclaggio meccanico o chimico, compostaggio, digestione anaerobica, programmi di ritiro, ecc.',
      calculationRequirement:
        'Il calcolo deve coprire tutte le emissioni previste da questi trattamenti, anche se avvengono negli anni futuri — come richiesto dalla Categoria 12 dello Scope 3 del GHG Protocol, Capitolo 12.',
      dataRequirements:
        'È necessario: (1) la massa totale dei prodotti + imballaggi venduti, e (2) la percentuale destinata a ciascun metodo di trattamento.',
      exclusions:
        'Escludere servizi, prodotti digitali o emissioni già riportate nella produzione, fase d’uso o altre categorie.',
      includeFinancials:
        'Includere: azioni quotate e obbligazioni societarie, prestiti societari, posizioni di project financing.',
      excludeFinancials:
        'Escludere: cassa di tesoreria, derivati o qualsiasi partecipazione già consolidata negli Scope 1-2 tramite approccio equity-share o di controllo.',
      helpBoxC5q2:
        'Se riconosci l’energia dell’asset nel tuo Scope 1 o 2, fermati qui – non utilizzare la Categoria 5.2 per evitare un doppio conteggio.',
      category6_title: 'Cosa rientra nella Categoria 6?',
      category6_intro:
        'Utilizzare questa sezione solo per fonti o pozzi di GHG indiretti che non rientrano logicamente nelle Categorie da 3 a 5. Esempi tipici includono:',
      category6_examples: [
        'Elettricità dei data center contrattualizzata al di fuori dei propri accordi di acquisto di energia.',
        'Emissioni di GHG da banchi di prova R&S esternalizzati presso siti partner.',
        'Emissioni una tantum da cambiamenti d’uso del suolo legati a progetti immobiliari specifici.',
        'Perdite di refrigerante da apparecchiature espositive temporanee che non si gestiscono direttamente.',
      ],
      category6_rule_of_thumb:
        'Regola pratica: se un’emissione è al di fuori dei propri confini diretti (Scope 1) o di energia importata (Scope 2) e non può essere inclusa nelle Categorie da 3 a 5, va registrata qui.',
      category6_must_supply: 'Informazioni da fornire obbligatoriamente',
      category6_supply_list: [
        'Descrizione in linguaggio semplice della fonte.',
        'Dati di attività (es. kWh, t km, kg di materiale).',
        'Fattore di emissione – selezionare uno disponibile nella libreria predefinita o inserire un fattore personalizzato documentato.',
        'Giustificazione che spieghi perché la fonte appartiene alla Categoria 6 e come è stato scelto il fattore.',
      ],
      category6_avoid_double_counting:
        'Evitare il doppio conteggio: se la descrizione si sovrappone a qualcosa già inserito in altre categorie, ricontrollare prima quelle.',
    },
  };

  async ngOnInit() {
    const savedCategory = Number(localStorage.getItem('currentCategory') ?? 0);
    const savedQuestion = Number(localStorage.getItem('currentQuestion') ?? 0);
    const savedViewState =
      (localStorage.getItem('currentViewState') as ViewState) ?? 'question';

    this.currentCategory = savedCategory;
    // If the saved question is a hidden question, advance to the first visible one
    this.currentQuestion = this.isHiddenQuestion(savedCategory, savedQuestion)
      ? savedQuestion + 1
      : savedQuestion;
    this.currentViewState = savedViewState;

    // Load calculation name from localStorage
    this.calculationName = localStorage.getItem('calculationName') || '';

    localStorage.setItem('currentViewState', this.currentViewState);

    this.categoryService.setCategories();

    this.emissionFactor = await this.climatiq.emissionFactor(
      this.currentCategory,
      this.currentQuestion,
    );
    this.loadSignificanceMatrix();
    this.loadUncertaintyMatrix();
    this.calculateCategoryTotals(this.currentCategory);
  }

  saveState = () => {
    localStorage.setItem('currentCategory', this.currentCategory.toString());
    localStorage.setItem('currentQuestion', this.currentQuestion.toString());
    localStorage.setItem('currentViewState', this.currentViewState);
    this.currentCat.setHighlightCategory(this.currentCategory);
  };

  saveCategories = async () => {
    const payload = this.categoryService.prepareCategoriesForPersistence(
      this.categories,
    );

    if (!payload) {
      return;
    }

    // Defer the localStorage write off the main thread to prevent Chrome freezes
    // with large payloads. The authoritative copy is always persisted via the API.
    this.categoryService.deferLocalStorageWrite(payload.serialized);
    this.categories = payload.categories;
    await this.api.UpdateCompanyDetails({
      id: localStorage.getItem('calculationId') ?? '',
      answers: payload.serialized,
    });

    // Auto-update invite status: registered → started
    if (
      this.isInvitedUser &&
      this.inviteRecord &&
      this.inviteRecord.status === 'registered'
    ) {
      await this.inviteServiceRef.updateInviteStatus(
        this.inviteRecord.id,
        'started',
      );
      this.inviteRecord = { ...this.inviteRecord, status: 'started' };
    }
  };

  isHiddenQuestion(catIndex: number, questionIndex: number): boolean {
    // Cat 2 Q1 hidden per client request
    return catIndex === 1 && questionIndex === 0;
  }

  visibleQuestionCount(catIndex: number): number {
    return (this.categories[catIndex]?.questions ?? []).filter(
      (_: any, x: number) => !this.isHiddenQuestion(catIndex, x),
    ).length;
  }

  visibleQuestionNumber(catIndex: number, questionIndex: number): number {
    const questions = this.categories[catIndex]?.questions ?? [];
    return questions
      .slice(0, questionIndex + 1)
      .filter((_: any, x: number) => !this.isHiddenQuestion(catIndex, x))
      .length;
  }

  isLastQuestionInCategory(): boolean {
    const questions = this.categories[this.currentCategory].questions;
    let lastVisible = questions.length - 1;
    while (
      lastVisible > 0 &&
      this.isHiddenQuestion(this.currentCategory, lastVisible)
    )
      lastVisible--;
    return this.currentQuestion === lastVisible;
  }

  isLastCategory(): boolean {
    return this.currentCategory === this.categories.length - 1;
  }

  nextQuestion = async () => {
    this.closeUploadModal();
    // Block navigation if the current question has incomplete required fields
    if (this.categoryService.blockNavigation()) {
      return;
    }
    // Only fetch emissions when advancing from a question view (not matrix/stepCompleted)
    if (this.currentViewState === 'question') {
      try {
        await this.climatiq.emissions(
          this.categories,
          this.currentCategory,
          this.currentQuestion,
        );
      } catch (err) {
        console.error(
          'Emissions calculation failed, proceeding with navigation:',
          err,
        );
      }
    }
    const question =
      this.categories[this.currentCategory].questions[this.currentQuestion];
    const matrixResult = this.buildClimatiqResultFromQuestion(question);
    this.loadUncertaintyMatrix();
    if (matrixResult) {
      this.attachClimatiqResult(question.id, matrixResult);
    }
    // Mark current question as done
    if (
      this.categories[this.currentCategory].questions[this.currentQuestion]
        .answers != null
    ) {
      this.categories[this.currentCategory].questions[
        this.currentQuestion
      ].done = true;
    }

    switch (this.currentViewState) {
      case 'question':
        this.calculateCategoryTotals(this.currentCategory);
        if (this.isLastQuestionInCategory()) {
          // Last question of category -> go to Matrix page
          this.currentViewState = 'matrix';
          this.loadSignificanceMatrix();
          this.loadUncertaintyMatrix();
        } else {
          // Not last question -> go to next question, skip hidden questions
          this.currentQuestion++;
          while (
            this.currentQuestion <
              this.categories[this.currentCategory].questions.length - 1 &&
            this.isHiddenQuestion(this.currentCategory, this.currentQuestion)
          ) {
            this.currentQuestion++;
          }
          this.loadSignificanceMatrix();
          this.loadUncertaintyMatrix();
          this.emissionFactor = await this.climatiq.emissionFactor(
            this.currentCategory,
            this.currentQuestion,
          );
        }
        break;

      case 'matrix':
        // Matrix page -> go to Step Completed page
        this.saveUncertaintyMatrix();
        this.saveSignificanceMatrix();
        this.currentViewState = 'stepCompleted';
        break;

      case 'stepCompleted':
        // Invited users: after completing Category 2 (index 1), show summary and mark as completed
        if (this.isInvitedUser && this.currentCategory === 1) {
          this.currentViewState = 'summary';
          this.currentCat.setViewState('summary');
          const nextCat = this.currentCategory + 1;
          this.currentCategory = nextCat;
          localStorage.setItem('currentCategory', nextCat.toString());
          this.currentCat.setCurrentCategory(nextCat);
          this.currentCat.setHighlightCategory(nextCat);
          // Update invite status to completed
          if (
            this.inviteRecord &&
            (this.inviteRecord.status === 'started' ||
              this.inviteRecord.status === 'registered')
          ) {
            await this.inviteServiceRef.updateInviteStatus(
              this.inviteRecord.id,
              'completed',
            );
            this.inviteRecord = { ...this.inviteRecord, status: 'completed' };
          }
        } else if (this.isLastCategory()) {
          this.currentViewState = 'summary';
          this.currentCat.setViewState('summary');
          const nextCat = this.currentCategory + 1;
          this.currentCategory = nextCat;
          localStorage.setItem('currentCategory', nextCat.toString());
          this.currentCat.setCurrentCategory(nextCat);
          this.currentCat.setHighlightCategory(nextCat);
        } else {
          const nextCat = this.currentCategory + 1;
          this.updateCategory(nextCat);

          this.emissionFactor = await this.climatiq.emissionFactor(
            this.currentCategory,
            this.currentQuestion,
          );
        }
        break;

      case 'summary':
        break;
    }

    this.saveCategories();
    this.saveState();
  };

  prevQuestion = async () => {
    this.closeUploadModal();
    switch (this.currentViewState) {
      case 'question':
        if (this.currentQuestion > 0) {
          // Go to previous question in same category, skip hidden questions
          this.currentQuestion--;
          while (
            this.currentQuestion > 0 &&
            this.isHiddenQuestion(this.currentCategory, this.currentQuestion)
          ) {
            this.currentQuestion--;
          }
          this.emissionFactor = await this.climatiq.emissionFactor(
            this.currentCategory,
            this.currentQuestion,
          );
        } else if (this.currentCategory > 0) {
          // Go to previous category's Step Completed page
          // this.currentCategory--;
          // this.currentQuestion = this.categories[this.currentCategory].questions.length - 1;
          const prevCat = this.currentCategory - 1;
          this.updateCategory(prevCat);
          this.currentViewState = 'question';
        }
        break;

      case 'matrix':
        // Matrix -> go back to last question of current category
        this.currentQuestion =
          this.categories[this.currentCategory].questions.length - 1;
        this.currentViewState = 'question';
        this.emissionFactor = await this.climatiq.emissionFactor(
          this.currentCategory,
          this.currentQuestion,
        );
        break;

      case 'stepCompleted':
        // Step Completed -> go back to Matrix page
        this.currentViewState = 'matrix';
        this.loadUncertaintyMatrix();
        this.loadSignificanceMatrix();
        break;

      case 'summary':
        // Summary -> go back to last category's Step Completed page
        this.currentCategory = this.categories.length - 1;
        this.currentQuestion =
          this.categories[this.currentCategory].questions.length - 1;
        this.currentViewState = 'stepCompleted';
        break;
    }
    this.saveCategories();
    this.saveState();
  };

  setQuestion = (category: number, question: number) => {
    this.currentCat.setViewState('question');
    this.currentCat.setCurrentCategory(category);
    this.currentQuestion = question;
  };

  public calculateCategoryTotals(categoryNum: any): EmissionTotals {
    const category = this.categories.find(
      (item: any) => item.id === `category${categoryNum + 1}`,
    );
    const totals: EmissionTotals = {
      co2: 0,
      ch4: 0,
      n2o: 0,
      co2e: 0,
    };

    category?.questions?.forEach((q: any) => {
      // Skip hidden questions (e.g. Cat 2 Q1 removed per client request)
      if (q.hidden) return;
      // Handle plain number emissions (e.g. lessor-specific method)
      if (typeof q.emissions === 'number') {
        totals.co2e += q.emissions;
        return;
      }
      if (!Array.isArray(q.emissions)) return;

      q.emissions.forEach((em: any) => {
        // Handle plain number elements within the array (e.g. Cat 6 custom factors)
        if (typeof em === 'number') {
          totals.co2e += em;
          return;
        }
        // Spend API nests data inside .estimate
        const data = em.estimate || em;
        const g = data.constituent_gases;

        if (g) {
          const co2 = Number(g.co2) || 0;
          const ch4 = Number(g.ch4) || 0;
          const n2o = Number(g.n2o) || 0;
          totals.co2 += co2;
          totals.ch4 += ch4;
          totals.n2o += n2o;
          // co2e_total and data.co2e are GWP-weighted; gasSum is raw kg (not CO2e)
          // Priority: co2e_total (explicit) → data.co2e (top-level) → gasSum (last resort)
          const gasSum = co2 + ch4 + n2o;
          totals.co2e +=
            g.co2e_total != null
              ? Number(g.co2e_total)
              : Number(data.co2e) || (gasSum > 0 ? gasSum : 0);
        } else if (data.co2e != null) {
          // Travel API: no constituent_gases, only top-level co2e
          totals.co2e += Number(data.co2e) || 0;
        }
      });
    });
    this.totalCh4 = totals.ch4;
    this.totalCo2 = totals.co2;
    this.totalN2O = totals.n2o;
    this.totalCo2e = totals.co2e;
    this.categories = this.categories.map((res: any) => {
      if (res.id == `category${categoryNum + 1}`) {
        return { ...res, calculation_category_totals: totals };
      } else {
        return res;
      }
    });
    return totals;
  }

  get totalCo2_t(): number {
    return this.totalCo2 / 1000;
  }

  get totalCh4_t(): number {
    return this.totalCh4 / 1000;
  }

  get totalN2O_t(): number {
    return this.totalN2O / 1000;
  }

  get totalCo2e_t(): number {
    return this.totalCo2e / 1000;
  }

  toggleHelp(event: MouseEvent) {
    event.stopPropagation();
    this.showHelp = !this.showHelp;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (this.showHelp) {
      this.showHelp = false;
    }
  }

  async directQuestion(x: any) {
    if (this.isHiddenQuestion(this.currentCategory, x)) return;
    this.currentQuestion = x;
    this.currentViewState = 'question';
    this.emissionFactor = await this.climatiq.emissionFactor(
      this.currentCategory,
      this.currentQuestion,
    );
    this.saveState();
  }

  openModal(row: SignificanceRow) {
    this.activeSignificanceRow = row;
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
    this.activeSignificanceRow = null;
  }

  fileuploadModal(row: UncertaintyRow) {
    this.activeUncertaintyRow = row;
    this.isuploadModalOpen = true;
  }

  closeUploadModal() {
    this.isuploadModalOpen = false;
    this.activeUncertaintyRow = null;
  }

  openNoteModal(row: UncertaintyRow) {
    this.activeNoteRow = row;
    this.newNoteText = '';
    this.isNoteModalOpen = true;
  }

  closeNoteModal() {
    this.isNoteModalOpen = false;
    this.activeNoteRow = null;
  }

  openInfoModal(type: 'significance' | 'uncertainty') {
    this.isInfoModalOpen = true;
    const isItalian = this.language === 'italian';

    if (type === 'significance') {
      this.infoModalTitle = isItalian
        ? 'Guida alla Matrice di Significatività'
        : 'Guide to the Significance Matrix';
      this.infoModalContent = isItalian
        ? this.getSignificanceContentIT()
        : `
        <p class="mb-3"><strong>Why this matrix matters</strong></p>
        <p class="mb-3">The Significance Matrix helps identify which emission sources are material to your organisation's carbon footprint. Each source (e.g. diesel use, electricity purchase) is evaluated across five criteria. You assign a score from 1 to 4 for each criterion. The scores are averaged (rounded up) to produce an overall Significance Level (LS). If LS ≥ 3, the source is considered significant and must be included in the footprint. You can always include a source even if it scores below 3 if, in your judgement, it is important.</p>

        <p class="mb-2"><strong>How to score each criterion</strong></p>

        <div class="overflow-x-auto">
        <table class="w-full mb-3 text-[12px] border-collapse min-w-[600px]">
          <thead class="sticky top-0 z-10">
            <tr class="bg-[#043B22] text-white">
              <th class="border border-[#043B22] px-2 py-1.5 text-left">Criterion</th>
              <th class="border border-[#043B22] px-2 py-1.5 text-left">Meaning</th>
              <th class="border border-[#043B22] px-2 py-1.5 text-left">How to score (1–4)</th>
              <th class="border border-[#043B22] px-2 py-1.5 text-left">Example</th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-gray-50">
              <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Magnitude</td>
              <td class="border border-gray-300 px-2 py-1.5">Relative size of the emissions compared to the company's total footprint.</td>
              <td class="border border-gray-300 px-2 py-1.5">1 = negligible; 2 = low; 3 = relevant; 4 = considerable.</td>
              <td class="border border-gray-300 px-2 py-1.5">A small office printer gets 1; a diesel generator (20% of emissions) gets 4.</td>
            </tr>
            <tr>
              <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Influence</td>
              <td class="border border-gray-300 px-2 py-1.5">Ability to control or reduce emissions from this source.</td>
              <td class="border border-gray-300 px-2 py-1.5">1 = no/very little; 2 = limited; 3 = moderate; 4 = full control.</td>
              <td class="border border-gray-300 px-2 py-1.5">Grid electricity (score 2); business vehicles you can switch to EVs (score 4).</td>
            </tr>
            <tr class="bg-gray-50">
              <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Risk/Opportunity</td>
              <td class="border border-gray-300 px-2 py-1.5">Climate-related risks (regulatory, financial, reputational) or opportunities.</td>
              <td class="border border-gray-300 px-2 py-1.5">1 = no significant; 2 = minor; 3 = relevant; 4 = major.</td>
              <td class="border border-gray-300 px-2 py-1.5">Refrigerants (regulatory risk, score 4); office supplies (score 1).</td>
            </tr>
            <tr>
              <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Employee Engagement</td>
              <td class="border border-gray-300 px-2 py-1.5">Extent employees' activities contribute and influence this source.</td>
              <td class="border border-gray-300 px-2 py-1.5">1 = minimal; 2 = some; 3 = high; 4 = very high involvement.</td>
              <td class="border border-gray-300 px-2 py-1.5">Employee commuting (score 3–4); data centre (score 1–2).</td>
            </tr>
            <tr class="bg-gray-50">
              <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Data Availability</td>
              <td class="border border-gray-300 px-2 py-1.5">Ease of obtaining accurate, reliable data for this source.</td>
              <td class="border border-gray-300 px-2 py-1.5">1 = very difficult; 2 = limited; 3 = good; 4 = very good data.</td>
              <td class="border border-gray-300 px-2 py-1.5">Missing fuel invoices (score 1); monthly electricity bills (score 4).</td>
            </tr>
          </tbody>
        </table>
        </div>

        <div class="p-2 bg-[#043B22]/10 rounded">
          <p class="text-[12px]"><strong>💡 Tip:</strong> After you score all five criteria, the system calculates the average and rounds up to the nearest whole number to determine the Significance Level (LS). If LS ≥ 3, the source is automatically marked as significant. You can override this if you believe a source is important even with a lower score.</p>
        </div>
      `;
    } else {
      this.infoModalTitle = isItalian
        ? 'Guida alla Matrice di Incertezza'
        : 'Guide to the Uncertainty Matrix';
      this.infoModalContent = isItalian
        ? this.getUncertaintyContentIT()
        : `
        <p class="mb-3"><strong>Why assess uncertainty?</strong></p>
        <p class="mb-3">Knowing the uncertainty of your data helps you evaluate the reliability of your carbon footprint. The Uncertainty Matrix asks you to rate two aspects of each activity's data: data quality and emission-factor reliability. Each aspect is broken down into six indicators. You score each indicator from 1 (very good) to 5 (very poor). The average score is then mapped to a percentage uncertainty, and the two uncertainties are combined into a single value for that activity using a well-defined formula.</p>

        <p class="mb-2"><strong>Indicators and scoring</strong></p>

        <div class="overflow-x-auto">
        <table class="w-full mb-3 text-[12px] border-collapse min-w-[700px]">
          <thead class="sticky top-0 z-10">
            <tr class="bg-[#043B22] text-white">
              <th class="border border-[#043B22] px-2 py-1.5 text-left">Indicator</th>
              <th class="border border-[#043B22] px-2 py-1.5 text-left">Description</th>
              <th class="border border-[#043B22] px-2 py-1.5 text-center">1 (Very good)</th>
              <th class="border border-[#043B22] px-2 py-1.5 text-center">3 (Fair)</th>
              <th class="border border-[#043B22] px-2 py-1.5 text-center">5 (Very poor)</th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-gray-50">
              <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Data Quality</td>
              <td class="border border-gray-300 px-2 py-1.5">Reliability and verification of the data source.</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Direct measurements or audited data</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Estimates based on typical usage</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Assumptions with no documents</td>
            </tr>
            <tr>
              <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Relevance</td>
              <td class="border border-gray-300 px-2 py-1.5">How closely the data reflect the specific activity.</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Data tied to same product/process</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Data from similar activities</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Data from unrelated activities</td>
            </tr>
            <tr class="bg-gray-50">
              <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Temporal Coverage</td>
              <td class="border border-gray-300 px-2 py-1.5">Age of the data relative to reporting period.</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Same reporting year</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Data 3–5 years old</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Data more than 10 years old</td>
            </tr>
            <tr>
              <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Geographical Coverage</td>
              <td class="border border-gray-300 px-2 py-1.5">Whether data come from same region/country.</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Same country or region</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Similar but not identical region</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Different region or unknown</td>
            </tr>
            <tr class="bg-gray-50">
              <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Technological Coverage</td>
              <td class="border border-gray-300 px-2 py-1.5">Similarity of technology or process.</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Identical equipment/process</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Similar technology</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Unknown or different technology</td>
            </tr>
            <tr>
              <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Completeness</td>
              <td class="border border-gray-300 px-2 py-1.5">Proportion of activities or sites covered.</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">All sites and activities covered</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Majority covered, some missing</td>
              <td class="border border-gray-300 px-2 py-1.5 text-center">Less than half covered</td>
            </tr>
          </tbody>
        </table>
        </div>

        <p class="mb-2"><strong>Mapping scores to uncertainty percentages</strong></p>
        <div class="mb-3 p-2 bg-gray-50 rounded text-[12px]">
          <div class="grid grid-cols-2 gap-1">
            <span>≤ 1.4 → <strong>2%</strong> (very high confidence)</span>
            <span>1.5–1.9 → <strong>5%</strong></span>
            <span>2.0–2.4 → <strong>10%</strong></span>
            <span>2.5–2.9 → <strong>15%</strong></span>
            <span>3.0–3.4 → <strong>20%</strong></span>
            <span>3.5–3.9 → <strong>30%</strong></span>
            <span>4.0–4.4 → <strong>40%</strong></span>
            <span>≥ 4.5 → <strong>50%</strong> (very low confidence)</span>
          </div>
        </div>

        <p class="mb-2 text-[12px]">The two percentage uncertainties (for activity data and emission factor) are combined using the quadrature formula: <strong>√(uncertainty₁² + uncertainty₂²)</strong>. For example, if both uncertainties are 10%, the combined uncertainty is √(10² + 10²) ≈ 14.1%.</p>

        <p class="mb-2"><strong>Why upload documents and add notes?</strong></p>
        <p class="mb-3 text-[12px]">You can upload supporting documents (e.g. invoices, meter readings, receipts, logbooks) and add notes to explain assumptions or data issues. This evidence makes your data more robust and helps verifiers understand how you arrived at each value.</p>

        <div class="p-2 bg-[#043B22]/10 rounded">
          <p class="text-[12px]"><strong>💡 Tip:</strong> A final uncertainty below 2% is considered approximate, between 2% and 2.5% is reliable, and 3% or more is very reliable. Strive for lower uncertainties by using primary data and specific emission factors.</p>
        </div>
      `;
    }
  }

  closeInfoModal() {
    this.isInfoModalOpen = false;
    this.infoModalTitle = '';
    this.infoModalContent = '';
  }

  getSignificanceContentIT(): string {
    return `
      <p class="mb-3"><strong>Perché questa matrice è importante</strong></p>
      <p class="mb-3">La Matrice di Significatività serve a individuare quali sorgenti di emissioni sono materiali per l'impronta di carbonio dell'organizzazione. Ogni sorgente (ad esempio consumo di gasolio o acquisto di elettricità) viene valutata secondo cinque criteri. A ciascun criterio si assegna un punteggio da 1 a 4. La media arrotondata per eccesso di questi punteggi produce il Livello di Significatività (LS). Se LS ≥ 3, la sorgente si considera significativa e deve essere inclusa nell'inventario. È sempre possibile includere una sorgente anche con un punteggio inferiore se, a vostro giudizio, è importante.</p>

      <p class="mb-2"><strong>Come valutare ciascun criterio</strong></p>

      <div class="overflow-x-auto">
      <table class="w-full mb-3 text-[12px] border-collapse min-w-[600px]">
        <thead class="sticky top-0 z-10">
          <tr class="bg-[#043B22] text-white">
            <th class="border border-[#043B22] px-2 py-1.5 text-left">Criterio</th>
            <th class="border border-[#043B22] px-2 py-1.5 text-left">Significato</th>
            <th class="border border-[#043B22] px-2 py-1.5 text-left">Come assegnare i punteggi (1–4)</th>
            <th class="border border-[#043B22] px-2 py-1.5 text-left">Esempio</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-gray-50">
            <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Magnitudine</td>
            <td class="border border-gray-300 px-2 py-1.5">Dimensione relativa delle emissioni rispetto al totale aziendale.</td>
            <td class="border border-gray-300 px-2 py-1.5">1 = trascurabile; 2 = bassa; 3 = rilevante; 4 = considerevole.</td>
            <td class="border border-gray-300 px-2 py-1.5">Una piccola stampante da ufficio (1); un generatore a gasolio (20% delle emissioni) (4).</td>
          </tr>
          <tr>
            <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Influenza</td>
            <td class="border border-gray-300 px-2 py-1.5">Capacità dell'azienda di controllare o ridurre queste emissioni.</td>
            <td class="border border-gray-300 px-2 py-1.5">1 = nessuna; 2 = limitata; 3 = moderata; 4 = controllo completo.</td>
            <td class="border border-gray-300 px-2 py-1.5">Elettricità di rete (2); veicoli aziendali (4).</td>
          </tr>
          <tr class="bg-gray-50">
            <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Rischio/Opportunità</td>
            <td class="border border-gray-300 px-2 py-1.5">Rischi climatici (normativi, finanziari, reputazionali) o opportunità.</td>
            <td class="border border-gray-300 px-2 py-1.5">1 = nessuno; 2 = minore; 3 = rilevante; 4 = elevato.</td>
            <td class="border border-gray-300 px-2 py-1.5">Refrigeranti (rischi regolamentari, 4); forniture d'ufficio (1).</td>
          </tr>
          <tr>
            <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Impegno dei dipendenti</td>
            <td class="border border-gray-300 px-2 py-1.5">Quanto le attività dei dipendenti contribuiscono e possono influenzare.</td>
            <td class="border border-gray-300 px-2 py-1.5">1 = minimo; 2 = qualche; 3 = alto; 4 = molto alto.</td>
            <td class="border border-gray-300 px-2 py-1.5">Pendolarismo (3–4); data center (1–2).</td>
          </tr>
          <tr class="bg-gray-50">
            <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Disponibilità dati</td>
            <td class="border border-gray-300 px-2 py-1.5">Facilità di reperire dati accurati e affidabili.</td>
            <td class="border border-gray-300 px-2 py-1.5">1 = molto difficile; 2 = limitati; 3 = buona; 4 = ottima.</td>
            <td class="border border-gray-300 px-2 py-1.5">Fatture carburanti mancanti (1); bollette mensili elettricità (4).</td>
          </tr>
        </tbody>
      </table>
      </div>

      <div class="p-2 bg-[#043B22]/10 rounded">
        <p class="text-[12px]"><strong>💡 Suggerimento:</strong> Dopo aver attribuito tutti i punteggi, il sistema calcola la media e la arrotonda al numero intero superiore per determinare il LS. Se LS ≥ 3, la sorgente viene inclusa automaticamente. Potete sempre modificare manualmente l'inclusione se ritenete una sorgente importante anche con un LS più basso.</p>
      </div>
    `;
  }

  getUncertaintyContentIT(): string {
    return `
      <p class="mb-3"><strong>Perché valutare l'incertezza?</strong></p>
      <p class="mb-3">La qualità dell'inventario dipende dalla affidabilità dei dati di input e dei fattori di emissione. La Matrice di Incertezza valuta due aspetti di ciascuna attività: qualità dei dati e affidabilità del fattore di emissione. Ogni aspetto è suddiviso in sei indicatori. Si attribuisce a ciascun indicatore un punteggio da 1 (ottimo) a 5 (molto scarso). La media viene poi convertita in una percentuale di incertezza, e i due valori vengono combinati con una formula quadratica.</p>

      <p class="mb-2"><strong>Indicatori e attribuzione dei punteggi</strong></p>

      <div class="overflow-x-auto">
      <table class="w-full mb-3 text-[12px] border-collapse min-w-[700px]">
        <thead class="sticky top-0 z-10">
          <tr class="bg-[#043B22] text-white">
            <th class="border border-[#043B22] px-2 py-1.5 text-left">Indicatore</th>
            <th class="border border-[#043B22] px-2 py-1.5 text-left">Descrizione</th>
            <th class="border border-[#043B22] px-2 py-1.5 text-center">1 (Ottimo)</th>
            <th class="border border-[#043B22] px-2 py-1.5 text-center">3 (Discreto)</th>
            <th class="border border-[#043B22] px-2 py-1.5 text-center">5 (Molto scarso)</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-gray-50">
            <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Qualità dei dati</td>
            <td class="border border-gray-300 px-2 py-1.5">Affidabilità e verifica della fonte.</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Misurazioni dirette o dati certificati</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Stime basate su consumi tipici</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Assunzioni prive di documentazione</td>
          </tr>
          <tr>
            <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Pertinenza</td>
            <td class="border border-gray-300 px-2 py-1.5">Vicinanza dei dati all'attività specifica.</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Dati riferiti allo stesso prodotto/processo</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Dati da prodotti simili</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Dati da attività non correlate</td>
          </tr>
          <tr class="bg-gray-50">
            <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Copertura temporale</td>
            <td class="border border-gray-300 px-2 py-1.5">Età dei dati rispetto al periodo di rendicontazione.</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Stesso anno di riferimento</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Dati di 3–5 anni fa</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Dati di oltre 10 anni</td>
          </tr>
          <tr>
            <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Copertura geografica</td>
            <td class="border border-gray-300 px-2 py-1.5">Se i dati provengono dalla stessa regione o Paese.</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Stessa regione o Paese</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Regione simile, non identica</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Regione diversa o sconosciuta</td>
          </tr>
          <tr class="bg-gray-50">
            <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Copertura tecnologica</td>
            <td class="border border-gray-300 px-2 py-1.5">Somiglianza della tecnologia o del processo.</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Apparecchiature/processi identici</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Tecnologia simile</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Tecnologia sconosciuta o diversa</td>
          </tr>
          <tr>
            <td class="border border-gray-300 px-2 py-1.5 font-semibold text-[#043B22]">Completezza</td>
            <td class="border border-gray-300 px-2 py-1.5">Quanta parte dell'attività o dei siti è coperta.</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Tutti i siti/attività coperti</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Maggioranza coperta</td>
            <td class="border border-gray-300 px-2 py-1.5 text-center">Meno della metà coperta</td>
          </tr>
        </tbody>
      </table>
      </div>

      <p class="mb-2"><strong>Conversione in percentuale di incertezza</strong></p>
      <div class="mb-3 p-2 bg-gray-50 rounded text-[12px]">
        <div class="grid grid-cols-2 gap-1">
          <span>≤ 1,4 → <strong>2%</strong> (confidenza molto alta)</span>
          <span>1,5–1,9 → <strong>5%</strong></span>
          <span>2,0–2,4 → <strong>10%</strong></span>
          <span>2,5–2,9 → <strong>15%</strong></span>
          <span>3,0–3,4 → <strong>20%</strong></span>
          <span>3,5–3,9 → <strong>30%</strong></span>
          <span>4,0–4,4 → <strong>40%</strong></span>
          <span>≥ 4,5 → <strong>50%</strong> (confidenza molto bassa)</span>
        </div>
      </div>

      <p class="mb-2 text-[12px]">Le incertezze di dati e fattori di emissione si combinano tramite la formula quadratica: <strong>√(incertezza₁² + incertezza₂²)</strong>. Ad esempio, se entrambe sono al 10%, l'incertezza combinata è √(10² + 10²) ≈ 14,1%.</p>

      <p class="mb-2"><strong>Caricamento documenti e note</strong></p>
      <p class="mb-3 text-[12px]">È possibile caricare documenti di supporto (fatture, letture dei contatori, ricevute, registri) e aggiungere note per giustificare le ipotesi o per segnalare problemi nei dati. Questa evidenza rende il vostro inventario più robusto e aiuta i verificatori a comprendere le scelte effettuate.</p>

      <div class="p-2 bg-[#043B22]/10 rounded">
        <p class="text-[12px]"><strong>💡 Nota:</strong> Un valore di incertezza inferiore al 2% è considerato approssimativo, tra 2% e 2,5% è affidabile, mentre 3% o più è molto affidabile. Migliorare la qualità dei dati e utilizzare fattori di emissione specifici riduce l'incertezza.</p>
      </div>
    `;
  }

  toggleRow(row: UncertaintyRow): void {
    row.expanded = !row.expanded;
  }

  confirmDeleteNote(noteId: string) {
    this.noteToDeleteId = noteId;
    this.isDeleteNoteModalOpen = true;
  }

  cancelDeleteNote() {
    this.isDeleteNoteModalOpen = false;
    this.noteToDeleteId = null;
  }

  deleteNoteConfirmed() {
    if (!this.activeNoteRow || !this.noteToDeleteId) return;
    this.activeNoteRow.notes = this.activeNoteRow.notes.filter(
      (note) => note.id !== this.noteToDeleteId,
    );
    this.saveUncertaintyMatrix();
    this.isDeleteNoteModalOpen = false;
    this.noteToDeleteId = null;
  }

  private _scoreOptionsCache: { lang: string; opts: { value: any; label: string }[] } | null = null;

  get scoreOptions() {
    const lang = this.language;
    if (this._scoreOptionsCache?.lang === lang) {
      return this._scoreOptionsCache.opts;
    }
    const opts = this.scoreMaster.map((s) => ({
      value: s.value,
      label: lang === 'english' ? s.engLabel : s.itaLabel,
    }));
    this._scoreOptionsCache = { lang, opts };
    return opts;
  }

  getFormControl(group: FormGroup, controlName: string): FormControl {
    return group.get(controlName) as FormControl;
  }

  // significance matrix logic //

  significanceRows: SignificanceRow[] = [];
  activeSignificanceRow: SignificanceRow | null = null;

  loadSignificanceMatrix() {
    this.significanceRows = [];
    const category = this.categories[this.currentCategory];
    if (!category) return;
    const storage: any = category.significanceMatrix;
    if (storage.length > 0) {
      this.significanceRows = storage.map((r: any) => ({
        ...r,
        elemento: this.getQuestionTitle(r.categoryId, r.questionId),
        form: new FormGroup<SignificanceRowForm>({
          magnitude: new FormControl<number | null | ''>(
            r.criteria.magnitude ?? '',
          ),
          influence: new FormControl<number | null | ''>(
            r.criteria.influence ?? '',
          ),
          riskOpportunity: new FormControl<number | null | ''>(
            r.criteria.riskOpportunity ?? '',
          ),
          stakeholderEngagement: new FormControl<number | null | ''>(
            r.criteria.stakeholderEngagement ?? '',
          ),
          dataAccessibility: new FormControl<number | null | ''>(
            r.criteria.dataAccessibility ?? '',
          ),
        }),
      }));
      return;
    }
    this.significanceRows = category.questions
      .filter((q: any) => !q.hidden)
      .map(
        (q: any): SignificanceRow => ({
          categoryId: category.id,
          questionId: q.id,
          elemento: this.getQuestionTitle(category.id, q.id),
          form: new FormGroup<SignificanceRowForm>({
            magnitude: new FormControl<number | null | ''>(''),
            influence: new FormControl<number | null | ''>(''),
            riskOpportunity: new FormControl<number | null | ''>(''),
            stakeholderEngagement: new FormControl<number | null | ''>(''),
            dataAccessibility: new FormControl<number | null | ''>(''),
          }),
          ls: 0,
          include: false,
          comment: '',
        }),
      );
  }

  recalculateLS(row: SignificanceRow) {
    const v = row.form.value;
    let values = [
      v.magnitude,
      v.influence,
      v.riskOpportunity,
      v.stakeholderEngagement,
      v.dataAccessibility,
    ].filter((x): x is number => x !== null && x !== '');
    if (values.length !== 5) {
      row.ls = 0;
      row.include = false;
      return;
    }
    values = values.map((res: any) => parseInt(res));
    row.ls = Number((values.reduce((a, b) => a + b) / 5).toFixed(1));
    row.include = row.ls >= 3;
  }

  toggleInclude(row: SignificanceRow) {
    row.include = !row.include;
  }

  saveSignificanceMatrix() {
    const categoryId = this.categories[this.currentCategory].id;
    const storage = this.significanceRows.map((r) => ({
      categoryId: r.categoryId,
      questionId: r.questionId,
      elemento: this.getQuestionTitle(r.categoryId, r.questionId),
      criteria: r.form.value,
      ls: r.ls,
      include: r.include,
      comment: r.comment,
    }));

    this.categories = this.categories.map((res: any) => {
      if (res.id == categoryId) {
        return { ...res, significanceMatrix: storage };
      } else {
        return res;
      }
    });
  }

  getQuestionTitle(categoryId: string, questionId: string): string {
    const category = this.categories.find((c) => c.id === categoryId);
    const question = category?.questions.find((q) => q.id === questionId);
    return question?.title || '';
  }

  get includedRows() {
    return this.significanceRows.filter((r) => r.include);
  }

  get excludedRows() {
    return this.significanceRows.filter((r) => !r.include);
  }

  saveComment() {
    if (!this.activeSignificanceRow) return;
    this.closeModal();
  }

  // Uncertainty matrix logic //
  uncertaintyRows: UncertaintyRow[] = [];
  activeUncertaintyRow: UncertaintyRow | null = null;
  isuploadModalOpen = false;
  allowedExtensions = [
    'pdf',
    'jpg',
    'jpeg',
    'png',
    'svg',
    'zip',
    'xls',
    'xlsx',
  ];
  maxFilesTotal = 10;
  isNoteModalOpen = false;
  activeNoteRow: UncertaintyRow | null = null;
  newNoteText = '';
  scoreMaster = [
    { value: 1, engLabel: 'Excellent', itaLabel: 'Ottimo' },
    { value: 2, engLabel: 'Good', itaLabel: 'Buono' },
    { value: 3, engLabel: 'Medium', itaLabel: 'Medio' },
    { value: 4, engLabel: 'Low', itaLabel: 'Scarso' },
    { value: 5, engLabel: 'Very poor', itaLabel: 'Pessimo' },
  ];

  private uncertaintySubs = new WeakMap<UncertaintyRow, any>();
  private toScore(value: any): Score | null {
    const n = Number(value);
    return Number.isFinite(n) && n >= 1 && n <= 5 ? (n as Score) : null;
  }

  private createScoreForm(values?: any): FormGroup<UncertaintyScoreForm> {
    return new FormGroup({
      data_quality: new FormControl<Score | null | ''>(
        this.toScore(values?.data_quality) ?? '',
      ),
      relevance: new FormControl<Score | null | ''>(
        this.toScore(values?.relevance) ?? '',
      ),
      temporal_coverage: new FormControl<Score | null | ''>(
        this.toScore(values?.temporal_coverage) ?? '',
      ),
      geographical_coverage: new FormControl<Score | null | ''>(
        this.toScore(values?.geographical_coverage) ?? '',
      ),
      technological_coverage: new FormControl<Score | null | ''>(
        this.toScore(values?.technological_coverage) ?? '',
      ),
      completeness: new FormControl<Score | null | ''>(
        this.toScore(values?.completeness) ?? '',
      ),
    });
  }

  private serializeUncertaintyRows(): any[] {
    return this.uncertaintyRows.map((row) => ({
      questionId: row.questionId,
      elementLabel: row.elementLabel,
      activityDataScores: row.activityDataForm.value,
      emissionFactorScores: row.emissionFactorForm.value,
      avgAD: row.avgAD,
      avgEF: row.avgEF,
      uncADPercent: row.uncADPercent,
      uncEFPercent: row.uncEFPercent,
      totalUncertaintyPercent: row.totalUncertaintyPercent,
      climatiqResult: row.climatiqResult,
      documents: row.documents,
      notes: row.notes,
    }));
  }

  loadUncertaintyMatrix() {
    const category = this.categories[this.currentCategory];
    if (!category) return;
    const storage: any = category.uncertaintyMatrix;
    const categoryId = category.id;
    const savedRows = storage || [];
    this.uncertaintyRows = category.questions
      .filter((q: any) => !q.hidden)
      .map((q: any) => {
        const saved = savedRows.find((r: any) => r.questionId === q.id);
        const row: UncertaintyRow = {
          categoryId,
          questionId: q.id,
          elementLabel: q.title,
          activityDataForm: this.createScoreForm(saved?.activityDataScores),
          emissionFactorForm: this.createScoreForm(saved?.emissionFactorScores),
          activityDataScores: saved?.activityDataScores,
          emissionFactorScores: saved?.emissionFactorScores,
          avgAD: saved?.avgAD ?? 0,
          avgEF: saved?.avgEF ?? 0,
          uncADPercent: saved?.uncADPercent ?? 0,
          uncEFPercent: saved?.uncEFPercent ?? 0,
          totalUncertaintyPercent: saved?.totalUncertaintyPercent ?? 0,
          climatiqResult: saved?.climatiqResult ?? null,
          documents: saved?.documents ?? [],
          notes: saved?.notes ?? [],
          expanded: false,
        };
        this.attachUncertaintyCalculation(row);
        return row;
      });
  }

  private calculateAverage(form: FormGroup<UncertaintyScoreForm>): number {
    const values = Object.values(form.value)
      .filter((v) => v !== null)
      .map((v) => Number(v));
    if (values.length !== 6) return 0;
    const avgRaw = values.reduce((a, b) => a + b, 0) / 6;
    return Number(avgRaw.toFixed(2));
  }

  private mapAvgToUncertainty(avg: number): number {
    if (avg <= 1.4) return 2;
    if (avg <= 1.9) return 5;
    if (avg <= 2.4) return 10;
    if (avg <= 2.9) return 15;
    if (avg <= 3.4) return 20;
    if (avg <= 3.9) return 30;
    if (avg <= 4.4) return 40;
    return 50;
  }

  private calculateTotalUncertainty(ad: number, ef: number): number {
    return Number(Math.sqrt(ad * ad + ef * ef).toFixed(2));
  }

  private attachUncertaintyCalculation(row: UncertaintyRow) {
    if (this.uncertaintySubs.has(row)) return;
    const sub = merge(
      row.activityDataForm.valueChanges,
      row.emissionFactorForm.valueChanges,
    )
      .pipe(debounceTime(300))
      .subscribe(() => {
        row.avgAD = this.calculateAverage(row.activityDataForm);
        row.avgEF = this.calculateAverage(row.emissionFactorForm);
        row.uncADPercent = this.mapAvgToUncertainty(row.avgAD);
        row.uncEFPercent = this.mapAvgToUncertainty(row.avgEF);
        row.totalUncertaintyPercent = this.calculateTotalUncertainty(
          row.uncADPercent,
          row.uncEFPercent,
        );
        this.categories = this.categories.map((res: any) => {
          if (res.id == row.categoryId) {
            res.uncertaintyMatrix = res.uncertaintyMatrix.map((col: any) => {
              if (col.questionId == row.questionId) {
                return {
                  ...row,
                  activityDataScores: row.activityDataForm.value,
                  emissionFactorScores: row.emissionFactorForm.value,
                };
              } else {
                return col;
              }
            });
            return res;
          } else {
            return res;
          }
        });
      });
    this.saveOverallUncertainty();
    this.uncertaintySubs.set(row, sub);
  }

  saveOverallUncertainty() {
    const overall = this.calculateOverallUncertainty();
    this.categories = this.categories.map((res: any) => {
      if (res.id == `category${this.currentCategory + 1}`) {
        return { ...res, overall_uncertainty: overall };
      } else {
        return res;
      }
    });
  }

  calculateOverallUncertainty(): number {
    let totalEmissions = 0;
    let weightedVarianceSum = 0;
    // Flatten all questions
    const questions =
      this.categories.find(
        (c: any) => c.id === `category${this.currentCategory + 1}`,
      )?.questions || [];

    questions.forEach((q: any) => {
      // Match uncertainty row
      const uncRow = this.uncertaintyRows.find((u) => u.questionId === q.id);
      if (!uncRow || !uncRow.totalUncertaintyPercent) return;
      // Sum emissions for this question
      const emissions = Array.isArray(q.emissions)
        ? q.emissions.reduce((s: number, e: any) => s + Number(e.co2e ?? 0), 0)
        : Number(q.emissions ?? 0);
      if (!emissions) return;
      totalEmissions += emissions;
      const u = uncRow.totalUncertaintyPercent / 100;
      weightedVarianceSum += Math.pow(emissions * u, 2);
    });
    if (!totalEmissions) return 0;
    const overall = Math.sqrt(weightedVarianceSum) / totalEmissions;
    return Number((overall * 100).toFixed(2)); // back to %
  }

  saveUncertaintyMatrix() {
    const categoryId = this.categories[this.currentCategory].id;
    const storage = this.uncertaintyRows.map((r) => ({
      questionId: r.questionId,
      elementLabel: r.elementLabel,
      activityDataScores: r.activityDataScores,
      emissionFactorScores: r.emissionFactorScores,
      avgAD: r.avgAD,
      avgEF: r.avgEF,
      uncADPercent: r.uncADPercent,
      uncEFPercent: r.uncEFPercent,
      totalUncertaintyPercent: r.totalUncertaintyPercent,
      climatiqResult: r.climatiqResult,
      documents: r.documents.map(({ base64, ...rest }) => rest),
      notes: r.notes,
    }));
    this.categories = this.categories.map((res: any) => {
      if (res.id == categoryId) {
        return { ...res, uncertaintyMatrix: storage };
      } else {
        return res;
      }
    });
  }

  attachClimatiqResult(questionId: string, result: ClimatiqResult) {
    this.uncertaintyRows = this.serializeUncertaintyRows();
    const row = this.uncertaintyRows.find((r) => r.questionId === questionId);
    if (!row) return;
    // row.climatiqResult = result;
    this.uncertaintyRows = this.uncertaintyRows.map((res: any) => {
      if (res.questionId === questionId) {
        return { ...row, climatiqResult: result };
      } else {
        return res;
      }
    });
    this.categories = this.categories.map((res: any) => {
      if (res.id == this.categories[this.currentCategory].id) {
        return {
          ...res,
          uncertaintyMatrix: this.uncertaintyRows.map((row: any) => ({
            ...row,
            documents: Array.isArray(row?.documents)
              ? row.documents.map(({ base64, ...rest }: any) => rest)
              : [],
          })),
        };
      } else {
        return res;
      }
    });
  }

  openFilePicker(): void {
    if (!this.fileInput?.nativeElement) {
      console.warn('File input not ready yet');
      return;
    }
    this.fileInput.nativeElement.click();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer?.files?.length) {
      this.handleFiles(event.dataTransfer.files);
    }
  }

  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    this.handleFiles(input.files);
    input.value = '';
  }

  async handleFiles(fileList: FileList): Promise<void> {
    if (!this.activeUncertaintyRow) return;
    const files = Array.from(fileList);
    for (const file of files) {
      // Global 10 file limit
      if (this.getTotalDocumentCount() >= this.maxFilesTotal) {
        alert('Maximum 10 documents allowed across all elements');
        break;
      }
      const ext = file.name.split('.').pop()?.toLowerCase();
      if (!ext || !this.allowedExtensions.includes(ext)) {
        alert(`Invalid file type: ${file.name}`);
        continue;
      }
      try {
        const base64 = await this.fileToBase64(file);
        this.activeUncertaintyRow.documents.push({
          file_id: crypto.randomUUID(),
          filename: file.name,
          uploaded_by: 'CM',
          uploaded_at: new Date().toISOString().split('T')[0],
          base64,
        });
      } catch (err) {
        console.error('File conversion failed:', err);
      }
    }
  }

  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        const base64 = result.split(',')[1]; // remove prefix
        resolve(base64);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

  removeFile(fileId: string): void {
    if (!this.activeUncertaintyRow) return;
    this.activeUncertaintyRow.documents =
      this.activeUncertaintyRow.documents.filter((d) => d.file_id !== fileId);
  }

  private base64ToBlob(base64: string, mime: string): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  }

  private getMimeType(filename: string): string {
    const ext = filename.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'pdf':
        return 'application/pdf';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      case 'svg':
        return 'image/svg+xml';
      case 'zip':
        return 'application/zip';
      case 'xls':
        return 'application/vnd.ms-excel';
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      default:
        return 'application/octet-stream';
    }
  }

  openFile(file: ElementDocument): void {
    if (!file.base64) {
      console.warn('File has no base64 data:', file.filename);
      return;
    }
    const mimeType = this.getMimeType(file.filename);
    const blob = this.base64ToBlob(file.base64, mimeType);
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  saveNote() {
    if (!this.activeNoteRow) return;
    const text = this.newNoteText.trim();
    if (!text) return;
    this.activeNoteRow.notes.unshift({
      id: crypto.randomUUID(),
      text,
      createdAt: new Date().toISOString(),
    });
    this.newNoteText = '';
    this.saveUncertaintyMatrix();
  }

  private buildClimatiqResultFromQuestion(
    question: any,
  ): ClimatiqResult | null {
    const emissions = question.emissions;
    if (!emissions || emissions.length === 0) {
      return null;
    }
    // Case 1: Standard Climatiq estimate array
    if (Array.isArray(emissions) && emissions[0]?.co2e != null) {
      const totalCo2e = emissions.reduce(
        (sum: number, e: any) => sum + Number(e.co2e ?? 0),
        0,
      );
      const first = emissions[0];
      return {
        co2e: Number(totalCo2e.toFixed(2)),
        co2e_unit: first.co2e_unit,
        co2e_calculation_method: first.co2e_calculation_method,
        co2e_calculation_origin: first.co2e_calculation_origin,
        activity_data: first.activity_data,
        emission_factor: first.emission_factor,
        audit_trail: first.audit_trail,
        notices: first.notices ?? [],
      };
    }

    // Case 2: Numeric-only emissions (manual calculations)
    if (typeof emissions === 'number') {
      return {
        co2e: emissions,
        co2e_unit: 'kg',
        co2e_calculation_method: 'calculated',
        co2e_calculation_origin: 'internal',
        activity_data: {
          activity_value: 0,
          activity_unit: '',
        },
        emission_factor: {
          id: '',
          name: '',
          activity_id: '',
          source: '',
          source_dataset: '',
          year: 0,
          region: '',
          category: '',
          access_type: '',
          source_lca_activity: '',
          data_quality_flags: [],
        },
        audit_trail: '',
        notices: [],
      };
    }

    return null;
  }

  getTotalDocumentCount(): number {
    return this.uncertaintyRows.reduce(
      (sum, r) => sum + (r.documents?.length || 0),
      0,
    );
  }

  get tableHeaders() {
    return [
      {
        key: 'element',
        label: this.language === 'english' ? 'ELEMENT' : 'ELEMENTO',
      },
      {
        key: 'en',
        label: 'EN',
        tooltip: this.language === 'english' ? 'Entity' : 'Entità',
      },
      {
        key: 'inf',
        label: 'INF',
        tooltip: this.language === 'english' ? 'Influence' : 'Influenza',
      },
      {
        key: 'ris',
        label: 'RIS/OPP',
        tooltip:
          this.language === 'english'
            ? 'Risks / Opportunities'
            : 'Rischi / Opportunità',
      },
      {
        key: 'imp',
        label: 'IMP',
        tooltip:
          this.language === 'english'
            ? 'Employee Engagement'
            : 'Impegno dipendenti',
      },
      {
        key: 'dd',
        label: 'DD',
        tooltip:
          this.language === 'english'
            ? 'Data Availability'
            : 'Disponibilità Dati',
      },
      {
        key: 'ls',
        label: 'LS',
        tooltip:
          this.language === 'english'
            ? 'Significance Index'
            : 'Indice di significatività',
      },
      {
        key: 'include',
        label: this.language === 'english' ? 'INCLUDE' : 'INCLUDI',
      },
      {
        key: 'note',
        label: this.language === 'english' ? 'NOTE' : 'NOTA',
      },
    ];
  }

  get activityTableHeaders() {
    const isEn = this.language === 'english';
    return [
      {
        label: isEn ? 'Element' : 'Elemento',
        colspan: 1,
        width: 'w-[20%]',
      },
      {
        label: isEn ? 'Activity Data' : 'Dati di Attività',
        colspan: 2,
        width: 'w-[17%]',
        center: true,
      },
      {
        label: isEn ? 'Summary' : 'Riepilogo',
        colspan: 1,
        width: 'w-[10%]',
        highlight: true,
      },
      {
        label: isEn ? 'Emission Factor' : 'Fattore di Emissione',
        colspan: 2,
        width: 'w-[17%]',
        center: true,
      },
      {
        label: isEn ? 'Summary' : 'Riepilogo',
        colspan: 1,
        width: 'w-[10%]',
        highlight: true,
      },
      {
        label: isEn ? 'Results & Actions' : 'Risultati e Azioni',
        colspan: 2,
        width: 'w-[16%]',
        center: true,
      },
    ];
  }

  get uncertaintyLabels() {
    const isEn = this.language === 'english';

    return {
      // Short codes
      DAT: isEn ? 'DAT' : 'DAT',
      REL: isEn ? 'REL' : 'REL',
      TEM: isEn ? 'TEM' : 'TEM',
      GEO: isEn ? 'GEO' : 'GEO',
      TEC: isEn ? 'TEC' : 'TEC',
      COM: isEn ? 'COM' : 'COM',

      // Tooltips
      dataQuality: isEn ? 'Data Quality' : 'Qualità dei Dati',
      relevance: isEn ? 'Relevance' : 'Rilevanza',
      temporal: isEn ? 'Temporal Coverage' : 'Copertura Temporale',
      geographical: isEn ? 'Geographical Coverage' : 'Copertura Geografica',
      technological: isEn ? 'Technological Coverage' : 'Copertura Tecnologica',
      completeness: isEn ? 'Completeness' : 'Completezza',

      // Summary labels
      avg: isEn ? 'AVG' : 'MEDIA',
      unc: isEn ? 'UNC' : 'INCERTEZZA',
      totalUnc: isEn ? 'TOTAL UNC' : 'INCERTEZZA TOTALE',

      // Actions
      docs: isEn ? 'DOCS' : 'DOC',
      note: isEn ? 'NOTE' : 'NOTA',
    };
  }

  private updateCategory(cat: number) {
    this.currentCategory = cat;
    this.currentQuestion = 0;
    this.currentViewState = 'question';

    // 🔑 sync with header
    this.currentCat.setCurrentCategory(cat);
    this.currentCat.setHighlightCategory(cat);
  }
}

export interface SignificanceRowForm {
  magnitude: FormControl<number | null | ''>;
  influence: FormControl<number | null | ''>;
  riskOpportunity: FormControl<number | null | ''>;
  stakeholderEngagement: FormControl<number | null | ''>;
  dataAccessibility: FormControl<number | null | ''>;
}
export interface SignificanceRow {
  categoryId: string;
  questionId: string;
  elemento: string;
  form: FormGroup<SignificanceRowForm>;
  ls: number;
  include: boolean;
  comment: string;
}
export interface ClimatiqResult {
  co2e: number;
  co2e_unit: string;
  co2e_calculation_method: string;
  co2e_calculation_origin: string;
  activity_data: {
    activity_value: number;
    activity_unit: string;
  };
  emission_factor: {
    id: string;
    name: string;
    activity_id: string;
    source: string;
    source_dataset: string;
    year: number;
    region: string;
    category: string;
    access_type: string;
    source_lca_activity: string;
    data_quality_flags: string[];
  };
  audit_trail: string;
  notices: any[];
}

export type Score = 1 | 2 | 3 | 4 | 5;
export interface UncertaintyScoreForm {
  data_quality: FormControl<Score | null | ''>;
  relevance: FormControl<Score | null | ''>;
  temporal_coverage: FormControl<Score | null | ''>;
  geographical_coverage: FormControl<Score | null | ''>;
  technological_coverage: FormControl<Score | null | ''>;
  completeness: FormControl<Score | null | ''>;
}
export interface UncertaintyRow {
  categoryId: string;
  questionId: string;
  elementLabel: string;
  activityDataForm: FormGroup<UncertaintyScoreForm>;
  emissionFactorForm: FormGroup<UncertaintyScoreForm>;
  emissionFactorScores: any;
  activityDataScores: any;
  avgAD: number;
  avgEF: number;
  uncADPercent: number;
  uncEFPercent: number;
  totalUncertaintyPercent: number;
  climatiqResult: ClimatiqResult | null;
  documents: ElementDocument[];
  expanded: boolean;
  notes: UncertaintyNote[];
}
interface ElementDocument {
  file_id: string;
  filename: string;
  uploaded_by: string;
  uploaded_at: string;
  base64?: string;
}
export interface UncertaintyNote {
  id: string;
  text: string;
  createdAt: string;
}
